import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      // Common translations
      "welcome": "Welcome",
      "login": "Login",
      "logout": "Logout",
      "register": "Register",
      "dashboard": "Dashboard",
      "profile": "Profile",
      "settings": "Settings",
      "search": "Search",
      "save": "Save",
      "cancel": "Cancel",
      "edit": "Edit",
      "delete": "Delete",
      "view": "View",
      "approve": "Approve",
      "reject": "Reject",
      "status": "Status",
      "actions": "Actions",
      
      // Navigation
      "busFinder": "Bus Finder",
      "routeFinder": "Route Finder",
      "busServices": "Bus Services",
      "operators": "Operators",
      "busStands": "Bus Stands",
      "routes": "Routes",
      "citiesVillages": "Cities & Villages",
      "myBookings": "My Bookings",
      
      // Admin specific
      "managementPanel": "Management Panel",
      "adminDashboard": "Admin Dashboard",
      "approvals": "Approvals",
      "manage": "Manage",
      
      // User specific
      "findBus": "Find Bus",
      "selectSeats": "Select Seats",
      "bookTickets": "Book Tickets",
      
      // Form labels
      "username": "Username",
      "password": "Password",
      "email": "Email",
      "phone": "Phone",
      "address": "Address",
      "name": "Name",
      "description": "Description",
      "from": "From",
      "to": "To",
      "date": "Date",
      "time": "Time",
      "price": "Price",
      "availableSeats": "Available Seats",
      "totalSeats": "Total Seats",
      
      // Messages
      "loginSuccess": "Login successful!",
      "logoutSuccess": "Logged out successfully!",
      "saveSuccess": "Saved successfully!",
      "deleteSuccess": "Deleted successfully!",
      "confirmDelete": "Are you sure you want to delete?",
      "noData": "No data available",
      "loading": "Loading...",
      
      // Errors
      "required": "This field is required",
      "invalidEmail": "Invalid email address",
      "invalidPhone": "Invalid phone number",
      "networkError": "Network error occurred",
      "unauthorized": "Unauthorized access",
      
      // Buttons
      "submit": "Submit",
      "reset": "Reset",
      "back": "Back",
      "next": "Next",
      "confirm": "Confirm",
      "close": "Close",
      "backToDashboard": "Back to Dashboard",
      "busServicesManagement": "Bus Services Management",
      "manageAllBusServicesDescription": "Manage all bus services, routes, schedules and approvals",
      "registerNewBusService": "Register New Bus Service",
      "addNewBusServiceDescription": "Add a new bus service with route, schedule, and other details",
      "viewAlterDeleteServices": "View/Alter/Delete Services",
      "manageExistingBusServicesDescription": "Manage existing bus services, update details or remove services",
      "approvalManagement": "Approval Management",
      "approveRejectBusServicesDescription": "Approve or reject pending bus service registrations",
      
      "busOperatorsManagement": "Bus Operators Management",
      "manageOperatorsDescriptionMain": "Manage bus operators, licenses, and approvals",
      "registerNewOperator": "Register New Operator",
      "registerOperatorDescription": "Register a new bus operator with license and contact details",
      "manageOperators": "Manage Operators",
      "manageOperatorsDescription": "View, update, or delete operator information",
      "operatorApprovals": "Operator Approvals",
      "operatorApprovalsDescription": "Approve or reject pending operator registrations",
      
      "manageBusServices": "Manage Bus Services",
      "manageAllBusRoutesDescription": "Manage all bus routes, schedules, and service details",
      "manageOperatorsCard": "Manage Operators",
      "manageBusOperatorsDescription": "Manage bus operators, licenses, and contact information",
      "manageNow": "Manage Now",
      
      "guestUser": "Guest User",
      "unknownRole": "Unknown Role",
      "offline": "Offline",
      "logoAlt": "Rajdoot Logo",
      "dashboard": "Dashboard",
      "busFinder": "Bus Finder",
      "routeFinder": "Route Finder",
      "notices": "Notices",
      "guide": "Guide",
      "settings": "Settings",
      "logout": "Logout",
      "mainMenu": "Main Menu",
      "logoAlt": "Rajdoot Logo",
      "guestUser": "Guest User",
      "unknownRole": "Unknown Role",
      "dashboard": "Dashboard",
      "busFinder": "Bus Finder",
      "routeFinder": "Route Finder",
      "notices": "Notices",
      "guide": "Guide",
      "settings": "Settings",
      "logout": "Logout",
      "mainMenu": "Main Menu",
      "user": "User",
      
      // Feature cards
      "busFinderPanel": "Bus Finder Panel",
      "routeFinderPanel": "Route Finder Panel",
      "noticeBoardPanel": "Notice Board Panel",
      "userGuidePanel": "User Guide Panel",
      "settingsPanel": "Settings Panel",
      
      // Descriptions
      "busFinderDescription": "Find buses and manage bus schedules",
      "routeFinderDescription": "Find and manage bus routes",
      "noticeBoardDescription": "Post and view important notices",
      "userGuideDescription": "User manual and instructions",
      "settingsDescription": "System and user settings",
      "logoutDescription": "Sign out from the system",
      
      // Welcome messages
      "welcomeBack": "Welcome back,",
      "dashboardDescription": "Manage your bus transportation system efficiently",
      "backToDashboard": "Back to Dashboard",
      "manageNow": "Manage Now",
      "superAdminView": "Super Admin View",
      
      // Bus Stops Management
      "busStopsManagement": "Bus Stops Management",
      "manageBusStopsDescriptionMain": "Manage bus stops, locations, and approvals",
      "registerNewBusStop": "Register New Bus Stop",
      "addNewBusStopDescription": "Add a new bus stop with location and facility details",
      "manageBusStops": "Manage Bus Stops",
      "manageBusStopsDescription": "View, update, or delete bus stop information",
      "busStopApprovals": "Bus Stop Approvals",
      "approveRejectBusStopDescription": "Approve or reject pending bus stop registrations",
      
      // Routes Management
      "routesManagement": "Routes Management",
      "manageAllRoutesDescription": "Manage all bus routes and schedules",
      "addNewRoute": "Add New Route",
      "createNewRouteDescription": "Create new bus routes with stops, schedules, and pricing",
      "manageRoutes": "Manage Routes",
      "manageRoutesDescription": "View, edit, or delete existing bus routes",
      "manageRouteApprovals": "Manage Route Approvals",
      "reviewRouteApprovalsDescription": "Review and approve pending route submissions",
      
      // Village/City Management
      "villageCityManagement": "Village/City Management",
      "manageGeoDetailsDescription": "Manage geo-spatial details of various spots and regions",
      "addNewVillageCity": "Add new Village/City",
      "registerNewVillageCityDescription": "Register a new Village/City",
      "manageVillageCity": "Manage Village/City",
      "manageVillageCityDescription": "View/Alter/Delete the details of a Village/City",
      "manageRegionApprovals": "Manage Region Approvals",
      "reviewRegionApprovalsDescription": "Review and approve pending village/city submissions",
      
      // Management Cards
      "manageBusRoutes": "Manage Bus Routes",
      "manageAllBusRoutesDescription": "Manage all bus routes, schedules, stops, and route details",
      "geoSpotsRegions": "Geo-spatial spots&regions",
      "manageGeoSpotsDescription": "Manage the geo-spatial details of various spots&regions",
      "manageBusStopsCard": "Manage Bus Stops",
      "manageBusStopsLocationsDescription": "Manage bus stops, locations, and facilities",
      
      // Dashboard
      "adminPrivilegesMessage": "You have administrative privileges. Additional approval management options are available.",
      "back": "Back",
      "busInformation": "Bus Information",
      "busNumberLabel": "Bus Number (8 digits starting with 5)",
      "busNumberPlaceholder": "e.g., 51234567",
      "busNumberHint": "Enter an 8-digit number starting with 5 (50000000-59999999)",
      "generateRandomTitle": "Generate random bus number",
      "generate": "Generate",
      "checkAvailabilityTitle": "Check if bus number is available",
      "check": "Check",
      // "busNumberAvailableStatus": "This bus number is available",
      "busNumberTakenStatus": "This bus number is already taken",
      "invalidFormatStatus": "Invalid format. Must be 8 digits starting with 5",
      
      "rtoRegistrationLabel": "RTO Registration Number",
      "rtoPlaceholder": "e.g., MP09FA1997",
      "rtoFormatHint": "Format: StateCode(2) + Digits(2) + Letters(2) + Digits(4)",
      
      "busNameLabel": "Bus Name",
      "busNamePlaceholder": "e.g., Volvo AC, City Express",
      
      "busContactLabel": "Bus Contact Number",
      "contactPlaceholder": "e.g., 9876543210",
      "contactHint": "10-digit mobile number",
      
      "stateLabel": "State",
      "selectStateOption": "-- Select State --",
      "selected": "Selected:",
      
      "zoneLabel": "Zone",
      "selectZoneOption": "-- Select Zone --",
      "selectStateFirst": "Please select a state first",
      "noZonesAvailable": "No zones available for this state",
      
      "statusLabel": "Status",
      "activeService": "Active Service",
      "activeServiceHint": "Bus will be available for booking",
      
      "operatorInformation": "Operator Information",
      "selectOperatorLabel": "Select Operator",
      "selectOperatorOption": "-- Select Operator --",
      "contact": "Contact",
      "appLink": "App Link",
      "website": "Website",
      
      "routeInformation": "Route Information",
      "selectRoutePathLabel": "Select Route Path",
      "selectRouteOption": "-- Select Route Path --",
      "routeNumber": "Route Number",
      "routeName": "Route Name",
      "routeVillagesCities": "Route Villages/Cities",
      
      "cancel": "Cancel",
      "registering": "Registering...",
      "registerBusService": "Register Bus Service",
      
      "registrationPreview": "Registration Preview",
      "busDetails": "Bus Details",
      "notSet": "Not set",
      "rtoRegistration": "RTO Registration",
      "busName": "Bus Name",
      "state": "State",
      "zone": "Zone",
      "active": "Active",
      "inactive": "Inactive",
      "numberStatus": "Number Status",
      "available": "Available",
      "taken": "Taken",
      "invalid": "Invalid",
      
      "operator": "Operator",
      "name": "Name",
      "number": "Number",
      "noOperatorSelected": "No operator selected",
      
      "route": "Route",
      "pathId": "Path ID",
      "villagesCities": "Villages/Cities",
      "noRouteSelected": "No route selected",
      
      // Validation messages
      "busNumberRequired": "Bus number is required",
      "busNumberFormatValidation": "Bus number must be exactly 8 digits starting with 5",
      "busNumberRangeValidation": "Bus number must be between 50000000 and 59999999",
      "rtoNumberRequired": "RTO Registration Number is required",
      "rtoNumberFormatError": "Invalid format. Expected: XX99XX9999 (e.g., MP09FA1997)",
      "busNameRequired": "Bus name is required",
      "selectOperatorRequired": "Please select an operator",
      "selectRouteRequired": "Please select a route path",
      "contactNumberRequired": "Bus contact number is required",
      "validContactNumberRequired": "Please enter a valid 10-digit contact number",
      "stateRequired": "State is required",
      "zoneRequired": "Zone is required",
      
      // Toast messages
      "enterBusNumberToCheck": "Please enter a bus number to check",
      "busNumberFormatError": "Bus number must be 8 digits starting with 5",
      "busNumberAvailable": "Bus number is available!",
      "busNumberTaken": "Bus number is already taken",
      "checkAvailabilityFailed": "Failed to check availability. Please try again.",
      "fixFormErrors": "Please fix the errors in the form",
      "proceedWithoutVerification": "Bus number availability has not been verified. Do you want to proceed anyway?",
      "busRegisteredSuccess": "Bus registered successfully",
      "serviceDetailsTitle": "Service Details",
      "busInformation": "Bus Information",
      "busNumber": "Bus Number",
      "busName": "Bus Name",
      "registrationNumber": "Registration Number",
      "contactNumber": "Contact Number",
      "operatorInformation": "Operator Information",
      "operatorNumber": "Operator Number",
      "operatorName": "Operator Name",
      "contact": "Contact",
      "routeInformation": "Route Information",
      "routePathNo": "Route Path No",
      "routePathName": "Route Path Name",
      "routeNo": "Route No",
      "administrativeDetails": "Administrative Details",
      "stateCode": "State Code",
      "stateName": "State Name",
      "zoneCode": "Zone Code",
      "zoneName": "Zone Name",
      "serviceStatus": "Service Status",
      "status": "Status",
      "active": "Active",
      "inactive": "Inactive",
      "close": "Close",
      "viewTravelHistory": "View Travel History",
      "travelHistoryTitle": "Travel History",
      "busService": "Bus Service",
      "filterByStatus": "Filter by Status",
      "allTrips": "All Trips",
      "completed": "Completed",
      "ongoing": "Ongoing",
      "cancelled": "Cancelled",
      "delayed": "Delayed",
      "totalTrips": "Total Trips",
      "totalPassengers": "Total Passengers",
      "totalRevenue": "Total Revenue",
      "loadingTravelHistory": "Loading travel history...",
      "noTravelHistory": "No travel history available for this bus",
      "date": "Date",
      "startTime": "Start Time",
      "endTime": "End Time",
      "driver": "Driver",
      "busNumber": "Bus Number",
      "passengers": "Passengers",
      "revenue": "Revenue",
      "incidents": "Incidents",
      "actions": "Actions",
      "none": "None",
      "exportHistory": "Export History",
      "back": "Back",
      "deactivateConfirm": "Are you sure you want to deactivate this bus service? This will set the status to inactive.",
      "deactivateSuccess": "Bus service deactivated successfully (status set to inactive)",
      "deactivateError": "Error deactivating bus service. Please try again.",
      "loadingMasterData": "Loading master data...",
      "operatorName": "Operator Name",
      "selectOperator": "Select Operator",
      "operatorNumber": "Operator Number",
      "autoFilledOperator": "Auto-filled when selecting operator",
      "stateName": "State Name",
      "selectState": "Select State",
      "stateCode": "State Code",
      "autoFilledState": "Auto-filled when selecting state",
      "zoneName": "Zone Name",
      "selectZone": "Select Zone",
      "zoneCode": "Zone Code",
      "autoFilledZone": "Auto-filled when selecting zone",
      "searching": "Searching...",
      "searchBuses": "Search Buses",
      "clearAll": "Clear All",
      "refresh": "Refresh",
      "exportData": "Export Data",
      "searchResults": "Search Results",
      "busServices": "Bus Services",
      "found": "found",
      "loadingSearchResults": "Loading search results...",
      "noServicesFound": "No bus services found matching your search criteria",
      "registrationNo": "Registration No.",
      "routePath": "Route Path",
      "viewDetails": "View Details",
      "editService": "Edit Service",
      "deactivateService": "Deactivate Service",
      "na": "N/A",
      "searchError": "Error searching buses. Please try again.",
      "registerNewBusOperator": "Register New Bus Operator",
      "fillDetailsBelow": "Fill in the details below to register a new bus operator",
      
      // Server error messages
      "serverResponseError": "Server responded with status {{status}}",
      "failedToLoadStates": "Failed to load states",
      "failedToLoadZones": "Failed to load zones",
      "failedToLoadDistricts": "Failed to load districts",
      "failedToLoadCitiesVillages": "Failed to load cities/villages",
      "failedToLoadData": "Failed to load required data. Please try again.",
      "failedToLoadDataRetry": "Failed to load data. Please try again.",
      "registrationFailed": "Registration failed",
      
      // Operator identification section
      "operatorIdentification": "Operator Identification",
      "operatorNumberLabel": "Operator Number (8 digits starting with 4)",
      "operatorNumberPlaceholder": "e.g., 41234567",
      "operatorNumberHint": "Enter an 8-digit number starting with 4 (40000000-49999999)",
      "generateOperatorNumber": "Generate random operator number",
      "checkAvailability": "Check operator number availability",
      "operatorNumberAvailableIndicator": "Operator number is available",
      "operatorNumberTakenIndicator": "Operator number is already taken",
      "operatorNumberInvalidFormat": "Invalid format. Must be 8 digits starting with 4",
      "enterOperatorNumber": "Please enter an operator number to check",
      "operatorNumberFormat": "Operator number must be 8 digits starting with 4",
      "operatorNumberTaken": "This operator number is already taken",
      "operatorNumberAvailable": "Operator number is available!",
      "operatorRegistered": "Operator registered successfully!",
      
      // Validation messages
      "operatorNumberRequired": "Operator number is required",
      "operatorNumberFormatValidation": "Operator number must be exactly 8 digits starting with 4",
      "operatorNumberRange": "Operator number must be between 40000000 and 49999999",
      
      // Operator Name section
      "operatorNameTitle": "Operator Name",
      "englishName": "English Name",
      "englishNamePlaceholder": "e.g., ABC Bus Services",
      "hindiName": "Hindi Name",
      "hindiNamePlaceholder": "e.g., एबीसी बस सर्विसेज",
      "validateEnglishName": "Validate English name",
      "validateHindiName": "Validate Hindi name",
      "validate": "Validate",
      "validNameIndicator": "Valid name",
      "invalidCharactersIndicator": "Contains invalid characters",
      "englishNameHint": "Enter operator name in English (letters and spaces only)",
      "hindiNameHint": "Enter operator name in Hindi",
      "enterNameFirst": "Please enter {{field}} name first",
      "invalidCharacters": "{{field}} name contains invalid characters",
      "validName": "{{field}} name is valid!",
      "englishNameRequired": "English operator name is required",
      "hindiNameRequired": "Hindi operator name is required",
      
      // Location Information
      "locationInformation": "Location Information",
      "selectState": "Select State",
      "selectZone": "Select Zone",
      "selectDistrict": "Select District",
      "selectCityVillage": "Select City/Village",
      "stateRequired": "State is required",
      "zoneRequired": "Zone is required",
      "districtRequired": "District is required",
      "cityVillageRequired": "City/Village is required",
      
      // Contact Information
      "contactInformation": "Contact Information",
      "mobileNumber": "Mobile Number",
      "mobileNumberPlaceholder": "e.g., 9876543210",
      "validateMobileNumber": "Validate mobile number",
      "removeNumber": "Remove this number",
      "addAnotherMobileNumber": "Add Another Mobile Number",
      "mobileNumberHint": "10-digit Indian mobile number",
      "enterMobileNumber": "Please enter a mobile number first",
      "validMobileNumber": "Mobile number is valid!",
      "invalidMobileNumber": "Please enter a valid 10-digit mobile number",
      "invalidMobileNumberFormat": "Invalid mobile number format",
      
      // Digital Presence
      "digitalPresence": "Digital Presence",
      "googlePlayStoreLink": "Google Play Store Link",
      "googlePlayStorePlaceholder": "https://play.google.com/store/apps/details?id=...",
      "appleAppStoreLink": "Apple App Store Link",
      "appleAppStorePlaceholder": "https://apps.apple.com/in/app/...",
      "invalidUrlFormat": "Invalid URL format",
      
      // Status Settings
      "statusSettings": "Status Settings",
      "activeStatus": "Active Status",
      "activeStatusHint": "Active operators will be available for bus services",
      
      // Loading states
      "loadingFormData": "Loading form data...",
      "retry": "Retry",
      "confirmCancel": "Are you sure? All unsaved changes will be lost.",
      
      // Button labels
      "registerOperator": "Register Operator",
      "registering": "Registering...",
      "busOperatorsManagement": "Bus Operators Management",
      "searchAndManageOperators": "Search and manage all bus operators in the system",
      "loadingMasterData": "Loading master data...",
      "noOperatorsFound": "No operators found matching your search criteria.",
      "searchError": "Error searching operators. Please try again.",
      
      // Search section
      "searchOperators": "Search Operators",
      "enterOperatorName": "Enter operator name",
      "enterOperatorNumber": "Enter operator number",
      "selectState": "Select State",
      "autoFilledState": "Auto-filled when selecting state",
      "selectZone": "Select Zone",
      "autoFilledZone": "Auto-filled when selecting zone",
      
      // Buttons
      "searching": "Searching...",
      "searchOperatorsButton": "Search Operators",
      "clearAll": "Clear All",
      "refresh": "Refresh",
      "registerNewOperator": "Register New Operator",
      
      // Table headers
      "searchResults": "Search Results",
      "operators": "Operators",
      "found": "found",
      "contactNumber": "Contact Number",
      "links": "Links",
      
      // Table content
      "loadingOperators": "Loading operators...",
      "na": "N/A",
      "active": "Active",
      "inactive": "Inactive",
      "app": "App",
      "website": "Website",
      "noLinks": "No links",
      
      // Action tooltips
      "clickToDeactivate": "Click to deactivate",
      "clickToActivate": "Click to activate",
      "viewDetails": "View Details",
      "deactivateOperator": "Deactivate Operator",
      
      // Confirmation messages
      "deactivateConfirm": "Are you sure you want to deactivate this operator? This will set the status to inactive.",
      "deactivateSuccess": "Operator deactivated successfully (status set to inactive)",
      "deactivateFailed": "Failed to deactivate operator",
      "deactivateError": "Error deactivating operator. Please try again.",
      
      // Status update messages
      "statusUpdated": "Operator {{status}} successfully!",
      "activated": "activated",
      "deactivated": "deactivated",
      "updateStatusFailed": "Failed to update operator status",
      "updateStatusError": "Error updating operator status. Please try again.",
      "addNewCityVillage": "Add New City/Village",
      "createCityVillageDescription": "Create new city or village entries for route planning",
      "httpError": "HTTP error! Status:",
      "failedToLoadDistricts": "Failed to load districts. Please try again.",
      "creationFailed": "Failed to create city/village. Status:",
      "cityVillageAdded": "City/Village added successfully!",
      "saveFailed": "Failed to save city/village. Please check your connection and try again.",
      
      // Form labels and placeholders
      "cityVillageInformation": "City/Village Information",
      "cityVillageNameLabel": "City/Village Name",
      "cityVillageNamePlaceholder": "e.g., Mysuru City Center",
      "cityVillageCode": "City/Village Code",
      "cityVillageCodePlaceholder": "e.g., MYC001",
      "uniqueIdentifierHint": "Unique identifier for this city/village",
      "loadingDistricts": "Loading districts...",
      
      // Status section
      "statusHint": "Uncheck to mark this city/village as inactive",
      
      // Button labels
      "creating": "Creating...",
      "createCityVillage": "Create City/Village",
      "cityVillageManagement": "City/Village Management",
      "searchManageDescription": "Search and manage city and village data using Code, State, or District filters",
      "failedToLoadStates": "Failed to load states data",
      "failedToLoadDistricts": "Failed to load districts data",
      "enterSearchCriteria": "Please enter at least one search criteria",
      "httpError": "HTTP error! Status:",
      "noCityVillagesFound": "No city/villages found matching your search criteria",
      "failedToFetchData": "Failed to fetch data. Please check your search criteria and try again.",
      "searchFailed": "Failed to search city/villages",
      "unknownError": "Unknown error",
      
      // Search section
      "searchCriteria": "Search Criteria",
      "enterCodePlaceholder": "Enter code (e.g., 613063)",
      "exactMatchRequired": "Exact match required",
      "selectStateOptional": "Select State (Optional)",
      "loadingStates": "Loading states...",
      "selectDistrictOptional": "Select District (Optional)",
      "loadingDistricts": "Loading districts...",
      
      // Status messages
      "deactivatedSuccess": "City/Village deactivated successfully (status set to inactive)",
      "deactivateFailed": "Failed to deactivate city/village:",
      "deactivateError": "Error deactivating city/village:",
      "statusUpdated": "City/Village {{status}} successfully!",
      "activated": "activated",
      "deactivated": "deactivated",
      "updateStatusError": "Error updating city/village status. Please try again.",
      "details": "details:",
      
      // Buttons and actions
      "clear": "Clear",
      "searching": "Searching...",
      "search": "Search",
      "searchingData": "Searching city/village data...",
      "recordsFound": "records found",
      "addNewCityVillage": "Add New City/Village",
      "deactivateCityVillage": "Deactivate City/Village",
      
      // Table headers
      "cityVillageName": "City/Village Name",
      "stateCode": "State Code",
      "districtCode": "District Code",
      
      // UI messages
      "note": "Note:",
      "searchInstructions": "Enter at least one of the three criteria to search. You can use any combination of Code, State, and District.",
      "searchResults": "Search Results",
      "noRecordsFound": "No records found matching your search criteria. Try different filters.",
      "readyToSearch": "Ready to Search",
      "enterCriteriaMessage": "Enter at least one search criteria above and click 'Search' to find city/village records.",
      "searchCombinationHint": "You can search by Code, State, District, or any combination.",
      
      // Modal and confirmations
      "confirmDeactivation": "Confirm Deactivation",
      "confirmDeactivationMessage": "Are you sure you want to deactivate this city/village? This will set the status to inactive.",
      
      // Common terms
      "unknown": "Unknown",
      "clickToDeactivate": "Click to deactivate",
      "clickToActivate": "Click to activate",
      "registerNewBusStand": "Register New Bus Stand",
      "fillDetailsBelow": "Fill in the details below to register a new bus stand",
      "failedToLoadCityVillageData": "Failed to load city/village data. Please try again later.",
      
      // Facility options (UI only)
      "waitingArea": "Waiting Area",
      "restrooms": "Restrooms",
      "foodCourt": "Food Court",
      "atm": "ATM",
      "ticketCounter": "Ticket Counter",
      "medicalRoom": "Medical Room",
      "parkingArea": "Parking Area",
      "wifi": "WiFi",
      "chargingStations": "Charging Stations",
      "informationDesk": "Information Desk",
      "luggageStorage": "Luggage Storage",
      "drinkingWater": "Drinking Water",
      
      // Validation messages
      "busStandCodeRequired": "Bus stand code is required",
      "busStandNameRequired": "Bus stand name is required",
      "cityVillageCodeRequired": "City/Village code is required",
      "validLatitudeRequired": "Valid latitude is required (-90 to 90)",
      "validLongitudeRequired": "Valid longitude is required (-180 to 180)",
      "invalidContactNumberFormat": "Invalid contact number format",
      "fixValidationErrors": "Please fix the validation errors before submitting.",
      
      // Basic Information section
      "basicInformation": "Basic Information",
      "busStandCodeLabel": "Bus Stand Code",
      "busStandCodePlaceholder": "e.g., BS001",
      "busStandCodeHint": "Alphanumeric code for the bus stand",
      "busStandNameLabel": "Bus Stand Name",
      "busStandNamePlaceholder": "e.g., Central Bus Terminal",
      "busStandNameHint": "Full name of the bus stand (min 3 characters)",
      
      // Location Details section
      "locationDetails": "Location Details",
      "selectCityVillageLabel": "Select City/Village",
      "loading": "Loading...",
      "searchCityVillagePlaceholder": "Search by name or code...",
      "selected": "Selected",
      "searchAndSelectHint": "Search and select from available cities/villages",
      "latitudeLabel": "Latitude",
      "getLocation": "Get Location",
      "latitudeHint": "Between -90 and 90 (e.g., 19.0760 for Mumbai)",
      "longitudeLabel": "Longitude",
      "longitudeHint": "Between -180 and 180 (e.g., 72.8777 for Mumbai)",
      "elevationLabel": "Elevation (Optional)",
      "elevationPlaceholder": "e.g., 14m above sea level",
      "elevationHint": "Optional - Height above sea level",
      
      // Contact Information section
      "contactInformation": "Contact Information",
      "contactNumberLabel": "Contact Number (Optional)",
      "contactNumberPlaceholder": "e.g., +91 9876543210",
      "contactNumberHint": "Format: +91 9876543210",
      
      // Success and error messages
      "busStandRegisteredSuccess": "Bus stand \"{{name}}\" registered successfully! Bus Stand Code: {{code}}",
      "busStandRegisteredAlert": "Bus Stand registered successfully",
      "busStandCodeExists": "Bus stand code already exists. Please use a different code.",
      "invalidData": "Invalid data. Please check your inputs.",
      "cityVillageNotFound": "City/Village not found. Please select a valid location.",
      "serverError": "Server error: {{status}} - {{statusText}}",
      "networkError": "Network error. Please check your connection and try again.",
      "unexpectedError": "An unexpected error occurred. Please try again.",
      
      // Confirmation and location messages
      "confirmCancel": "Are you sure? All unsaved changes will be lost.",
      "unableToRetrieveLocation": "Unable to retrieve your location. Please enter coordinates manually.",
      "geolocationNotSupported": "Geolocation is not supported by your browser.",
      
      // UI labels
      "noCityVillageFound": "No city/village found",
      "na": "N/A",
      "active": "Active",
      "registerBusStand": "Register Bus Stand",
      "registering": "Registering...",
      "busStandsManagement": "Bus Stands Management",
      "searchManageBusStandsDescription": "Search and manage bus stands by state, zone, or name",
      "failedToLoadBusStandsData": "Failed to load bus stands data",
      "failedToLoadStatesData": "Failed to load states data",
      "failedToLoadZonesData": "Failed to load zones data",
      "noBusStandsFound": "No bus stands found with the given criteria",
      "failedToSearchBusStands": "Failed to search bus stands",
      
      // Search form
      "searchBusStands": "Search Bus Stands",
      "enterBusStandCode": "Enter bus stand code",
      "searchByName": "Search by name",
      "selectState": "Select State",
      "selectZone": "Select Zone",
      
      // Button labels
      "reset": "Reset",
      "searchBusStandsButton": "Search Bus Stands",
      "registerNewBusStandButton": "Register New Bus Stand",
      
      // Table headers and labels
      "busStandsFound": "bus stands found",
      "standCode": "Stand Code",
      "standName": "Stand Name",
      "coordinates": "Coordinates",
      "elevation": "Elevation",
      
      // Status and actions
      "openInGoogleMaps": "Open in Google Maps",
      "deactivateBusStand": "Deactivate Bus Stand",
      "addNewBusStand": "Add New Bus Stand",
      
      // Error and success messages
      "unknownError": "Unknown error",
      "httpError": "HTTP error! status:",
      "deactivatedSuccess": "Bus stand deactivated successfully (status set to inactive)",
      "deactivateFailed": "Failed to deactivate bus stand:",
      "deactivateError": "Error deactivating bus stand:",
      "statusUpdated": "Bus stand {{status}} successfully!",
      "details": "details:",
      "updateStatusError": "Error updating bus stand status. Please try again.",
      
      // UI messages
      "noBusStandsFoundTitle": "No Bus Stands Found",
      "enterSearchCriteria": "Enter search criteria to find bus stands",
      "searchingBusStands": "Searching bus stands...",
      
      // Modal messages
      "confirmDeactivationMessage": "Are you sure you want to deactivate this bus stand? This will set the status to inactive.",
      "editBusServiceTitle": "Edit Bus Service: {{registrationNumber}}",
      "editBusServiceDescription": "Update the details for bus service \"{{busName}}\"",
      "busNotFound": "Bus service with number \"{{busNo}}\" not found.",
      "failedToLoadBusData": "Failed to load bus service data. Please try again later.",
      "loadingBusServiceData": "Loading bus service data...",
      
      // Validation messages
      "busNumberRequired": "Bus number is required",
      "busNumberMustBeNumber": "Bus number must be a number",
      "busNumberGreaterThanZero": "Bus number must be greater than 0",
      "registrationNumberRequired": "Registration number is required",
      "busNameRequired": "Bus name is required",
      "selectOperatorRequired": "Please select an operator",
      "selectRoutePathRequired": "Please select a route path",
      "contactNumberRequired": "Bus contact number is required",
      "valid10DigitContactNumber": "Please enter a valid 10-digit contact number",
      "stateRequired": "State is required",
      "zoneRequired": "Zone is required",
      "fixFormErrors": "Please fix the errors in the form",
      
      // Form labels and placeholders
      "busNumberLabel": "Bus Number",
      "busNumberPlaceholder": "e.g., 101, 202, 303",
      "uniqueBusNumberHint": "Enter a unique bus number",
      "registrationNumberLabel": "Registration Number",
      "registrationNumberPlaceholder": "e.g., MP-01-MO-1234",
      "registrationNumberFormatHint": "Format: XX-XX-XX-XXXX",
      "busNameLabel": "Bus Name",
      "busNamePlaceholder": "e.g., Volvo AC, City Express",
      "busContactNumberLabel": "Bus Contact Number",
      "contactNumberPlaceholder": "e.g., 9876543210",
      "contactNumberHint": "10-digit mobile number",
      "stateLabel": "State",
      "selectStateOption": "-- Select State --",
      "selectedState": "Selected: {{stateName}}",
      "zoneLabel": "Zone",
      "selectZoneOption": "-- Select Zone --",
      "selectStateFirst": "Please select a state first",
      "noZonesAvailable": "No zones available for this state",
      "selectedZone": "Selected: {{zoneName}}",
      "statusLabel": "Status",
      "activeService": "Active Service",
      "activeServiceHint": "Bus will be available for booking",
      
      // Section titles
      "busInformation": "Bus Information",
      "operatorInformation": "Operator Information",
      "routeInformation": "Route Information",
      
      // Operator and route selection
      "selectOperatorLabel": "Select Operator",
      "selectOperatorOption": "-- Select Operator --",
      "selectRoutePathLabel": "Select Route Path",
      "selectRoutePathOption": "-- Select Route Path --",
      
      // Error and success messages
      "busUpdatedSuccess": "Bus service \"{{busName}}\" updated successfully!",
      "busServiceNotFound": "Bus service not found. It may have been deleted.",
      "invalidData": "Invalid data. Please check your inputs.",
      "busNumberConflict": "Bus number conflict. Please use a different number.",
      "serverError": "Server error: {{status}} - {{statusText}}",
      "networkError": "Network error. Please check your connection and try again.",
      "unexpectedError": "An unexpected error occurred. Please try again.",
      
      // Delete related
      "confirmDeleteBusService": "Are you sure you want to delete this bus service? This action cannot be undone.",
      "busServiceDeleted": "Bus service deleted successfully!",
      "busServiceNotFoundDelete": "Bus service not found. It may have already been deleted.",
      "failedToDeleteBusService": "Failed to delete bus service. Please try again.",
      "confirmCancelChanges": "Are you sure? All unsaved changes will be lost.",
      "confirmDelete": "Confirm Delete",
      "confirmDeleteMessage": "Are you sure you want to delete the bus service \"{{busName}}\" (Bus No: {{busNo}})?",
      "deleteWarning": "This action cannot be undone. All associated data will be permanently deleted.",
      "deletePermanently": "Delete Permanently",
      
      // Button labels
      "deleteBusService": "Delete Bus Service",
      "updateBusService": "Update Bus Service",
      "deleting": "Deleting...",
      "updating": "Updating...",
      
      // Preview section
      "updatePreview": "Update Preview",
      "busDetails": "Bus Details",
      "notSet": "Not set",
      "registration": "Registration",
      "noOperatorSelected": "No operator selected",
      "noRouteSelected": "No route selected",
      "pathId": "Path ID",
      
      // Common terms
      "appLink": "App Link",
      "website": "Website",
      "routeNumber": "Route Number",
      "routeName": "Route Name",
      "addBusTimetable": "Add Bus Timetable",
      "failedToFetchRoutePaths": "Failed to fetch route paths data",
      "routePathRequired": "Route path is required",
      "busStandRequired": "Bus stand is required",
      "busNumberRequired": "Bus number is required",
      "arrivalTimeRequired": "Arrival time is required",
      "departureTimeRequired": "Departure time is required",
      "departureAfterArrival": "Departure time must be after arrival time",
      "timetableAddedSuccess": "Timetable entry added successfully!",
      "failedToAddTimetable": "Failed to add timetable entry. Please check the console for details.",
      "routePath": "Route Path",
      "selectRoutePath": "Select route path",
      "busStand": "Bus Stand",
      "loadingBusStands": "Loading bus stands...",
      "selectBusStand": "Select bus stand",
      "noBusStandsFound": "No bus stands found for this route path",
      "busNumber": "Bus Number",
      "loadingBuses": "Loading buses...",
      "selectBus": "Select bus",
      "noBusesFound": "No buses found for this route path",
      "arrivalTime": "Arrival Time",
      "departureTime": "Departure Time",
      "addingTimetableEntry": "Adding timetable entry...",
      "adding": "Adding...",
      "addTimetableEntry": "Add Timetable Entry",
      "resetForm": "Reset Form",
      "findBuses": "Bus Finder",
      "from": "From",
      "to": "To",
      "selectDepartureCity": "Select departure city",
      "selectDestinationCity": "Select destination city",
      "searchBuses": "Search Buses",
      "searching": "Searching...",
      "loadingCities": "Loading Cities...",
      "popularRoutes": "Popular Routes",
      "selectBothLocations": "Please select both From and To locations",
      "invalidCitySelection": "Invalid city selection",
      "failedToLoadCities": "Failed to load cities. Using sample data.",
      "failedToSearchBuses": "Failed to search buses. Please try again.",
      "bus": "Bus",
      "unknownOperator": "Unknown Operator",
      "na": "N/A",
      "pm": "PM",
      "am": "AM",
      "ac": "AC",
      "wifi": "Wifi",
      "charging": "Charging",
      "movie": "Movie",
      "blanket": "Blanket",
      "snacks": "Snacks",
      "water": "Water",
      "sleeper": "SLEEPER",
      "seater": "SEATER",
      "busFinder": "Bus Finder",
      "home": "Home",
      "searchingForBuses": "Searching for buses...",
      "availableBuses": "Available Buses",
      "filterResults": "Filter Results",
      "departure": "From",
      "duration": "Duration",
      "arrival": "Arrival",
      "seatsAvailable": "Seats Available",
      "amenities": "Amenities",
      "showArrivalDepartureDetails": "Show Arrival & Departure Details",
      "busDetails": "Bus Details",
      "busInformation": "Bus Information",
      "contact": "Contact",
      "route": "Route",
      "routeNumber": "Route Number",
      "busStand": "Bus Stand",
      "schedule": "Schedule",
      "noBusesFound": "No buses found for your search",
      "tryDifferentRoutes": "Try different routes",
      "busManagementSystem": "Bus Management System",
      "footerDescription": "Your trusted partner for comfortable and reliable bus travel.",
      "quickLinks": "Quick Links",
      "notices": "Notices",
      "contactUs": "Contact Us",
      "support": "Support",
      "helpCenter": "Help Center",
      "faq": "FAQ",
      "privacyPolicy": "Privacy Policy",
      "termsOfService": "Terms of Service",
      "allRightsReserved": "All rights reserved",
      "timetableManagement": "Manage TimeTable",
      "manageBusTimetablesDescription": "Manage bus arrival and departure timetables at bus stands",
      "addTimetable": "Add Timetable",
      "addNewTimetableDescription": "Add new arrival and departure timetables for bus stands",
      "addNewTimetableEntry": "Add new arrival and departure timetable for buses at bus stands",
      "viewTimetables": "View Timetables",
      "viewManageTimetablesDescription": "View, search and manage all timetables",
      "viewManageAllTimetables": "View and manage all bus arrival and departure timetables",
      "manageTimetables": "Manage Timetables",
      "busStand": "Bus Stand",
      "arrivalTime": "Arrival Time",
      "departureTime": "Departure Time",
      "activeStatus": "Active Status",
      "adding": "Adding...",
      "timetableAddedSuccess": "Timetable added successfully!",
      "failedToAddTimetable": "Failed to add timetable. Please try again.",
      "busDetails": "Bus Details",
      "busRegistrationNumber": "Bus Registration Number",
      "busName": "Bus Name",
      "active": "Active",
      "inactive": "Inactive",
      "actions": "Actions",
      "refresh": "Refresh",
      "addNew": "Add New",
      "filterResults": "Filter Results",
      "allBusStands": "All Bus Stands",
      "allBuses": "All Buses",
      "editTimetable": "Edit Timetable",
      "deleteTimetable": "Delete Timetable",
      "confirmDeleteTimetable": "Are you sure you want to delete this timetable?",
      "deleteSuccess": "Timetable deleted successfully",
      "loading": "Loading...",
      "selectBusStand": "Select a bus stand",
      "selectBus": "Select a bus",
      "arrivalDepartureTimes": "Arrival & Departure Times",
      "reset": "Reset",
      "submit": "Submit",
      "busNumber": "Bus Number",
      "busStandName": "Bus Stand Name",
      "arrival": "Arrival",
      "status": "Status",
      "viewDetails": "View Details",
      "edit": "Edit",
      "delete": "Delete",
      "noTimetablesFound": "No timetables found. Try changing your filters or add a new timetable.",
      "loadingData": "Loading data...",
      "busStandCode": "Bus Stand Code",
      "time": "Time",
      "save": "Save",
      "cancel": "Cancel",
      "logoAlt": "Bus Management System Logo",
      "busFinder": "Bus Finder",
      "home": "Home",
      "findBuses": "Bus Finder",
      "departure": "From",
      "state": "State",
      "selectState": "Select State",
      "loadingStates": "Loading states...",
      "noStatesAvailable": "No states available",
      "district": "District",
      "selectDistrict": "Select District",
      "loadingDistricts": "Loading districts...",
      "noDistrictsAvailable": "No districts available",
      "selectCity": "Select City",
      "loadingCities": "Loading cities...",
      "noCitiesAvailable": "No cities available",
      "destination": "Destination",
      "searchBuses": "Search Buses",
      "searching": "Searching...",
      "popularRoutes": "Popular Routes",
      "availableBuses": "Available Buses",
      "filterResults": "Filter Results",
      "duration": "Duration",
      "arrival": "Arrival",
      "seatsAvailable": "Seats Available",
      "amenities": "Amenities",
      "showBusDetails": "Show Bus Details",
      "busDetails": "Bus Details",
      "busInformation": "Bus Information",
      "contact": "Contact",
      "status": "Status",
      "route": "Route",
      "routeName": "Route Name",
      "routeNumber": "Route Number",
      "busStand": "Bus Stand",
      "busStandContact": "Bus Stand Contact",
      "additionalDetails": "Additional Details",
      "busStatus": "Bus Status",
      "operatorContact": "Operator Contact",
      "zone": "Zone",
      "perPassenger": "per passenger",
      "selectSeats": "Select Seats",
      "busInactive": "Bus Inactive",
      "apiError": "API Error",
      "tryAgainLater": "No buses right now. Please try again later.",
      "noBusesFound": "No Buses Found",
      "tryDifferentRoutes": "Try different routes or dates",
      "busManagementSystem": "Bus Management System",
      "footerDescription": "Your reliable partner for comfortable and safe bus journeys across India.",
      "quickLinks": "Quick Links",
      "notices": "Notices",
      "contactUs": "Contact Us",
      "support": "Support",
      "helpCenter": "Help Center",
      "faq": "FAQ",
      "privacyPolicy": "Privacy Policy",
      "termsOfService": "Terms of Service",
      "allRightsReserved": "All rights reserved",
      "selectBothLocations": "Please select both departure and destination locations",
      "searchingForBuses": "Searching for buses...",
      "active": "Active",
      "inactive": "Inactive",
      "notAvailable": "N/A",
      "unknownRoute": "Unknown Route",
      "mainBusStand": "Main Bus Stand",
      "busDetails": "Bus Details",
      "back": "Back",
      "logoAlt": "Rajdoot Logo",
      "rajdootBusDetails": "Rajdoot - Bus Details",
      "home": "Home",
      "departureLocation": "Departure Location",
      "destinationLocation": "Destination Location",
      "travelDuration": "Travel Duration",
      "departureTime": "Departure Time",
      "arrivalTime": "Arrival Time",
      "routeDetails": "Route Details",
      "totalDistance": "Total Distance",
      "averageSpeed": "Average Speed",
      "tollBooths": "Toll Booths",
      "roadCondition": "Road Condition",
      "popularBusStops": "Popular Bus Stops",
      "type": "Type",
      "timeFromIndore": "Time from Indore",
      "availableAmenities": "Available Amenities",
      "timetable": "Timetable",
      "contactDetails": "Contact Details",
      "appsWebsites": "Apps & Websites",
      "busInformation": "Bus Information",
      "completeTimetable": "Complete Timetable",
      "showingSchedule": "Showing schedule for all stops",
      "busStopBusStand": "Bus Stop / Bus Stand",
      "arrival": "Arrival",
      "day": "Day",
      "gpsLocation": "GPS Location",
      "map": "Map",
      "stopType": "Stop Type",
      "details": "Details",
      "mainStop": "Main Stop",
      "intermediateStop": "Intermediate Stop",
      "hide": "Hide",
      "view": "View",
      "pickupPoints": "Pickup points",
      "intermediateStops": "Intermediate stops",
      "time": "Time",
      "mobileNumbersBooking": "Mobile Numbers for Booking",
      "busOperatorContact": "Bus Operator Contact",
      "callNow": "Call Now",
      "websitesBooking": "Websites for Booking",
      "mobileAppsBooking": "Mobile Apps",
      "openWebsite": "Open Website",
      "downloadApp": "Download App",
      "busNumber": "Bus Number",
      "routeNumber": "Route Number",
      "registrationYear": "Registration Year",
      "busType": "Bus Type",
      "seatingCapacity": "Seating Capacity",
      "insuranceValidUntil": "Insurance Valid Until",
      "busStandInformation": "Bus Stand Information",
      "departureStand": "Departure Stand",
      "timings": "Timings",
      "arrivalStand": "Arrival Stand",
      "policiesTerms": "Policies & Terms",
      "cancellationPolicy": "Cancellation Policy",
      "luggageAllowance": "Luggage Allowance",
      "boardingTime": "Boarding Time",
      "childPolicy": "Child Policy",
      "idProof": "ID Proof",
      "rescheduling": "Rescheduling",
      "additionalInformation": "Additional Information",
      "operatorAddress": "Operator Address",
      "yearsOfService": "Years of Service",
      "totalBuses": "Total Buses",
      "customerRating": "Customer Rating",
      "safetyRating": "Safety Rating",
      "amenitiesFacilities": "Amenities & Facilities",
      "notAvailable": "Not Available",
      "safetyAdditionalFacilities": "Safety & Facilities",
      "bookNow": "Book Now",
      "shareDetails": "Share Details",
      "rajdootBusService": "Rajdoot Bus Service",
      "footerDescription": "India's reliable bus booking service. Safe, comfortable and timely travel experience.",
      "quickLinks": "Quick Links",
      "findBus": "Find Bus",
      "myBookings": "My Bookings",
      "notices": "Notices",
      "helpSupport": "Help & Support",
      "helpCenter": "Help Center",
      "contactUs": "Contact Us",
      "faq": "FAQ",
      "privacyPolicy": "Privacy Policy",
      "contactInformation": "Contact Information",
      "helpline": "Helpline",
      "email": "Email",
      "office": "Office",
      "rajdootExplorations": "Rajdoot Explorations",
      "allRightsReserved": "All rights reserved",
      "busName": "Bus Name",
      "acSeaterSleeper": "AC Seater/Sleeper",
      "nonStop": "Non-stop",
      "ac": "AC",
      "seater": "Seater",
      "sleeper": "Sleeper",
      "water": "Water",
      "snacks": "Snacks",
      "charging": "Charging",
      "wifi": "Wifi",
      "duration2h5m": "2 hours 5 minutes",
      "mainBusStandPlatform": "Main Bus Stand, Platform A-12",
      "pickup": "Pickup",
      "collegeGate": "In front of college gate",
      "mainHighwayRoad": "Main Highway Road",
      "drop": "Drop",
      "highwayCrossing": "Highway Crossing",
      "finalDestinationStop": "Final Destination Stop",
      "mainBusStandPlatformB": "Main Bus Stand, Platform B-08",
      "major": "Major",
      "landmark": "Landmark",
      "industrial": "Industrial",
      "district": "District",
      "destination": "To",
      "highway": "Highway",
      "good": "Good",
      "primaryBooking": "Primary Booking",
      "whatsappBooking": "WhatsApp Booking",
      "smsBooking": "SMS Booking",
      "landline": "Landline",
      "groupBooking": "Group Booking",
      "operatorMrMohan": "Operator (Mr. Mohan)",
      "managerMrsReena": "Manager (Mrs. Reena)",
      "emergency": "Emergency",
      "complaints": "Complaints",
      "rajdootOfficialWebsite": "Rajdoot Official Website",
      "officialBookingPortal": "Official booking portal with live tracking",
      "onlineBookingPortal": "Online Booking Portal",
      "directBooking": "Direct booking with instant confirmation",
      "operatorWebsite": "Operator Website",
      "operatorOfficialSite": "official site",
      "serviceFeedback": "Service Feedback",
      "rateYourJourney": "Rate your journey experience",
      "mpRoadwaysPortal": "MP Roadways Portal",
      "governmentBusServices": "Government bus services portal",
      "seats42": "42 seats",
      "waitingRoom": "Waiting Room",
      "cafeteria": "Cafeteria",
      "toilets": "Toilets",
      "parking": "Parking",
      "cloakRoom": "Cloak Room",
      "open247": "Open 24/7",
      "waitingArea": "Waiting Area",
      "teaStall": "Tea Stall",
      "localTransportCounter": "Local Transport Counter",
      "airConditioning": "Air Conditioning",
      "freeWifi": "Free WiFi",
      "chargingPorts": "Charging Ports",
      "waterBottles": "Water Bottles",
      "snacksPack": "Snacks Pack",
      "blankets": "Blankets",
      "newspaperMagazine": "Newspaper/Magazine",
      "entertainmentSystem": "Entertainment System",
      "readingLights": "Reading Lights",
      "footRests": "Foot Rests",
      "recliningSeats": "Reclining Seats",
      "curtains": "Curtains",
      "gpsTracking": "GPS Tracking",
      "realTimeBusTracking": "Real-time bus tracking",
      "cctvCameras": "CCTV Cameras",
      "securitySurveillance": "24/7 security surveillance",
      "immediateContactSupport": "Immediate contact support",
      "travelInsurance": "Travel Insurance",
      "coveragePerPassenger": "₹5 Lakh coverage per passenger",
      "firstAidBox": "First Aid Box",
      "medicalAssistance": "Medical assistance available",
      "fireExtinguisher": "Fire Extinguisher",
      "safetyEquipment": "Safety equipment on board",
      "wheelchairAccess": "Wheelchair Access",
      "availableOnRequest": "Available on request",
      "childSeats": "Child Seats",
      "cancellationPolicyText": "Cancellation allowed 24 hours before departure (50% charge)",
      "luggagePolicyText": "15kg per passenger (additional ₹50/kg)",
      "boardingPolicyText": "Report 30 minutes before departure time",
      "childPolicyText": "Children below 5 years free (no seat)",
      "idProofPolicyText": "ID Proof mandatory during journey",
      "smokingPolicyText": "Smoking and alcohol strictly prohibited",
      "petsPolicyText": "Pets not allowed",
      "lateBoardingPolicyText": "No responsibility for late boarding",
      "reschedulingPolicyText": "Rescheduling allowed 6 hours before departure",
      "refundPolicyText": "Refunds processed within 7 working days",
      "years15": "15 Years",
      "buses25": "25+ Buses",
      "routes50": "50+ Routes",
      "bestPrivateOperator": "Best Private Bus Operator 2022",
      "partnerHotels": "5+ Partner hotels for overnight stays",
      "shareWhatsappText": "Rajdoot Bus Service:  Travels (Number) - Indore to Badwah",
      "review1": "Comfortable journey, clean bus, professional staff. Would recommend!",
      "review2": "Punctual service, good amenities. Driver was very careful.",
      "review3": "Value for money. Could improve snacks quality.",
      "detailsCopied": "Bus details copied to clipboard!",
      "regNo": "Reg. No."
    }
  },
  hi: {
    translation: {
      // Common translations
      "welcome": "स्वागत है",
      "login": "लॉगिन",
      "logout": "लॉगआउट",
      "register": "पंजीकरण",
      "dashboard": "डैशबोर्ड",
      "profile": "प्रोफ़ाइल",
      "settings": "सेटिंग्स",
      "search": "खोज",
      "save": "सहेजें",
      "cancel": "रद्द करें",
      "edit": "संपादित करें",
      "delete": "हटाएं",
      "view": "देखें",
      "approve": "अनुमोदित करें",
      "reject": "अस्वीकार करें",
      "status": "स्थिति",
      "actions": "कार्रवाई",
      
      // Navigation
      "busFinder": "बस प्रदर्शक", // Fixed according to design doc
      "routeFinder": "लोकल बसें ढूंढें", // Fixed according to design doc
      "busServices": "बस सेवाएं",
      "operators": "ऑपरेटर",
      "busStands": "बस स्टैंड",
      "routes": "रूट",
      "citiesVillages": "शहर और गांव",
      "myBookings": "मेरी बुकिंग",
      
      // Admin specific
      "managementPanel": "प्रबंधन पैनल",
      "adminDashboard": "व्यवस्थापक डैशबोर्ड",
      "approvals": "अनुमोदन",
      "manage": "प्रबंधित करें",
      
      // User specific
      "findBus": "बसें ढूंढें", // Fixed according to design doc
      "selectSeats": "सीट चुनें",
      "bookTickets": "टिकट बुक करें",
      
      // Form labels
      "username": "उपयोगकर्ता नाम",
      "password": "पासवर्ड",
      "email": "ईमेल",
      "phone": "फ़ोन",
      "address": "पता",
      "name": "नाम",
      "description": "विवरण",
      "from": "कहाँ से", // Fixed according to design doc
      "to": "कहाँ तक", // Fixed according to design doc
      "date": "तारीख",
      "time": "समय",
      "price": "कीमत",
      "availableSeats": "उपलब्ध सीटें",
      "totalSeats": "कुल सीटें",
      
      // Messages
      "loginSuccess": "लॉगिन सफल!",
      "logoutSuccess": "सफलतापूर्वक लॉगआउट!",
      "saveSuccess": "सफलतापूर्वक सहेजा गया!",
      "deleteSuccess": "सफलतापूर्वक हटाया गया!",
      "confirmDelete": "क्या आप वाकई हटाना चाहते हैं?",
      "noData": "कोई डेटा उपलब्ध नहीं",
      "loading": "लोड हो रहा है...",
      
      // Errors
      "required": "यह फ़ील्ड आवश्यक है",
      "invalidEmail": "अमान्य ईमेल पता",
      "invalidPhone": "अमान्य फ़ोन नंबर",
      "networkError": "नेटवर्क त्रुटि हुई",
      "unauthorized": "अनधिकृत पहुंच",
      
      // Buttons
      "submit": "जमा करें",
      "reset": "रीसेट",
      "back": "वापस",
      "next": "आगे",
      "confirm": "पुष्टि करें",
      "close": "बंद करें",
      "busFinder": "बस प्रदर्शक", // Fixed according to design doc
      "routeFinder": "लोकल बसें ढूंढें", // Fixed according to design doc
      "notices": "टीम के बारे में", // Fixed according to design doc
      "guide": "सिस्टम का उपयोग करना सीखें", // Fixed according to design doc
      "userGuide": "यूज़र गाइड", // Fixed according to design doc
      "aboutTeam": "टीम के बारे में", // Fixed according to design doc
      "findBusDescription": "लोकल बसें ढूंढें", // Fixed according to design doc
      "findOptimalRoutes": "इष्टतम मार्ग खोजें",
      "viewAnnouncements": "नवीनतम घोषणाएं देखें",
      "systemControls": "सिस्टम नियंत्रण",
      "howToUse": "सिस्टम का उपयोग करना सीखें", // Fixed according to design doc
      "meetOurTeam": "हमारी टीम को जानें", // Fixed according to design doc
      "comingSoonRouteFinder": "रूट फाइंडर सुविधा जल्द ही आ रही है!",
      "comingSoonNotices": "सूचना सुविधा जल्द ही आ रही है!",
      "comingSoonControlPanel": "नियंत्रण पैनल जल्द ही आ रहा है!",
      "comingSoonUserGuide": "उपयोगकर्ता गाइड जल्द ही आ रहा है!",
      "comingSoonAboutTeam": "टीम पृष्ठ जल्द ही आ रहा है!",
      "logoAlt": "बस प्रबंधन प्रणाली लोगो",
      "systemName": "बस प्रबंधन प्रणाली",
      "welcomeMessage": "सभी बस परिवहन आवश्यकताओं के लिए आपका एक-स्टॉप समाधान",
      "administration": "प्रशासन",
      "adminDescription": "सिस्टम व्यवस्थापक और प्रबंधन कर्मचारियों के लिए",
      "managementPanel": "प्रबंधन पैनल",
      "adminAccess": "व्यवस्थापक और प्रबंधन पहुंच",
      "systemOverview": "सिस्टम अवलोकन",
      "activeBuses": "सक्रिय बसें",
      "routes": "मार्ग",
      "dailyUsers": "दैनिक उपयोगकर्ता",
      "allRightsReserved": "सर्वाधिकार सुरक्षित",
      "privacyPolicy": "गोपनीयता नीति",
      "termsOfService": "सेवा की शर्तें",
      "contactUs": "हमसे संपर्क करें",
      "welcomeMessageLogin": "राजदूत परिवहन प्रबंधन प्रणाली में आपका स्वागत है",
      "logoAlt": "राजदूत लोगो",
      "busImageAlt": "बस पृष्ठभूमि",
      "login": "लॉगिन",
      "register": "पंजीकरण",
      "firstName": "पहला नाम",
      "lastName": "अंतिम नाम",
      "email": "ईमेल",
      "password": "पासवर्ड",
      "confirmPassword": "पासवर्ड की पुष्टि करें",
      "role": "भूमिका",
      "userRole": "उपयोगकर्ता",
      "driverRole": "ड्राइवर",
      "conductorRole": "कंडक्टर",
      "registering": "पंजीकरण हो रहा है...",
      "signingIn": "साइन इन हो रहा है...",
      "signIn": "साइन इन करें",
      "alreadyHaveAccount": "क्या आपके पास पहले से खाता है?",
      "noAccount": "क्या आपके पास अभी तक कोई खाता नहीं है?",
      "registerForFree": "मुफ्त में पंजीकरण करें",
      "showPassword": "पासवर्ड दिखाएं",
      "hidePassword": "पासवर्ड छिपाएं",
      "passwordMismatch": "पासवर्ड मेल नहीं खाते।",
      "passwordMinLength": "पासवर्ड कम से कम 6 वर्ण लंबा होना चाहिए।",
      "welcomeMessageLanding": "राजदूत परिवहन प्रबंधन प्रणाली में आपका स्वागत है",
      "logoAlt": "राजदूत लोगो",
      "busImageAlt": "बस छवि",
      "login": "लॉगिन",
      "logoAlt": "राजदूत लोगो",
      "guestUser": "अतिथि उपयोगकर्ता",
      "unknownRole": "अज्ञात भूमिका",
      "dashboard": "डैशबोर्ड",
      "busFinder": "बस प्रदर्शक", // Fixed according to design doc
      "routeFinder": "लोकल बसें ढूंढें", // Fixed according to design doc
      "notices": "टीम के बारे में", // Fixed according to design doc
      "guide": "सिस्टम का उपयोग करना सीखें", // Fixed according to design doc
      "settings": "सेटिंग्स",
      "logout": "लॉगआउट",
      "mainMenu": "मुख्य मेनू",
      "user": "उपयोगकर्ता",
      
      // Feature cards
      "busFinderPanel": "बस खोजकर्ता पैनल",
      "routeFinderPanel": "रूट खोजकर्ता पैनल",
      "noticeBoardPanel": "नोटिस बोर्ड पैनल",
      "userGuidePanel": "उपयोगकर्ता गाइड पैनल",
      "settingsPanel": "सेटिंग्स पैनल",
      
      // Descriptions
      "busFinderDescription": "बस और बस अनुसूची प्रबंधित करें",
      "routeFinderDescription": "बस मार्ग खोजें और प्रबंधित करें",
      "noticeBoardDescription": "महत्वपूर्ण सूचनाएं पोस्ट करें और देखें",
      "userGuideDescription": "उपयोगकर्ता मैनुअल और निर्देश",
      "settingsDescription": "सिस्टम और उपयोगकर्ता सेटिंग्स",
      "logoutDescription": "सिस्टम से साइन आउट करें",
      
      // Welcome messages
      "welcomeBack": "वापसी पर स्वागत है,",
      "dashboardDescription": "अपनी बस परिवहन प्रणाली को कुशलता से प्रबंधित करें",
      "backToDashboard": "डैशबोर्ड पर वापस जाएं",
      "busServicesManagement": "बस सेवा प्रबंधन",
      "manageAllBusServicesDescription": "सभी बस सेवाओं, मार्गों, समय सारिणी और अनुमोदनों का प्रबंधन करें",
      "registerNewBusService": "नई बस सेवा पंजीकृत करें",
      "addNewBusServiceDescription": "मार्ग, समय सारिणी और अन्य विवरणों के साथ एक नई बस सेवा जोड़ें",
      "viewAlterDeleteServices": "सेवाएं देखें/बदलें/हटाएं",
      "manageExistingBusServicesDescription": "मौजूदा बस सेवाओं का प्रबंधन करें, विवरण अपडेट करें या सेवाएं हटाएं",
      "approvalManagement": "अनुमोदन प्रबंधन",
      "approveRejectBusServicesDescription": "लंबित बस सेवा पंजीकरणों को अनुमोदित या अस्वीकार करें",
      
      "busOperatorsManagement": "बस ऑपरेटर प्रबंधन",
      "manageOperatorsDescriptionMain": "बस ऑपरेटरों, लाइसेंस और अनुमोदनों का प्रबंधन करें",
      "registerNewOperator": "नया ऑपरेटर पंजीकृत करें",
      "registerOperatorDescription": "लाइसेंस और संपर्क विवरणों के साथ एक नए बस ऑपरेटर को पंजीकृत करें",
      "manageOperators": "ऑपरेटर प्रबंधित करें",
      "manageOperatorsDescription": "ऑपरेटर जानकारी देखें, अपडेट करें या हटाएं",
      "operatorApprovals": "ऑपरेटर अनुमोदन",
      "operatorApprovalsDescription": "लंबित ऑपरेटर पंजीकरणों को अनुमोदित या अस्वीकार करें",
      
      "manageBusServices": "बस सेवाएं प्रबंधित करें",
      "manageAllBusRoutesDescription": "सभी बस मार्गों, समय सारिणी और सेवा विवरणों का प्रबंधन करें",
      "manageOperatorsCard": "ऑपरेटर प्रबंधित करें",
      "manageBusOperatorsDescription": "बस ऑपरेटरों, लाइसेंस और संपर्क जानकारी का प्रबंधन करें",
      "manageNow": "अभी प्रबंधित करें",
      
      "guestUser": "अतिथि उपयोगकर्ता",
      "unknownRole": "अज्ञात भूमिका",
      "offline": "ऑफ़लाइन",
      "logoAlt": "राजदूत लोगो",
      "dashboard": "डैशबोर्ड",
      "busFinder": "बस प्रदर्शक", // Fixed according to design doc
      "routeFinder": "लोकल बसें ढूंढें", // Fixed according to design doc
      "notices": "टीम के बारे में", // Fixed according to design doc
      "guide": "सिस्टम का उपयोग करना सीखें", // Fixed according to design doc
      "settings": "सेटिंग्स",
      "logout": "लॉगआउट",
      "mainMenu": "मुख्य मेनू",
      "backToDashboard": "डैशबोर्ड पर वापस जाएं",
      "manageNow": "अभी प्रबंधित करें",
      "superAdminView": "सुपर एडमिन व्यू",
      
      // Bus Stops Management
      "busStopsManagement": "बस स्टॉप प्रबंधन",
      "manageBusStopsDescriptionMain": "बस स्टॉप, स्थान और अनुमोदन प्रबंधित करें",
      "registerNewBusStop": "नया बस स्टॉप पंजीकृत करें",
      "addNewBusStopDescription": "स्थान और सुविधा विवरणों के साथ एक नया बस स्टॉप जोड़ें",
      "manageBusStops": "बस स्टॉप प्रबंधित करें",
      "manageBusStopsDescription": "बस स्टॉप जानकारी देखें, अपडेट करें या हटाएं",
      "busStopApprovals": "बस स्टॉप अनुमोदन",
      "approveRejectBusStopDescription": "लंबित बस स्टॉप पंजीकरणों को अनुमोदित या अस्वीकार करें",
      
      // Routes Management
      "routesManagement": "मार्ग प्रबंधन",
      "manageAllRoutesDescription": "सभी बस मार्गों और समय सारिणी का प्रबंधन करें",
      "addNewRoute": "नया मार्ग जोड़ें",
      "createNewRouteDescription": "स्टॉप, समय सारिणी और मूल्य निर्धारण के साथ नए बस मार्ग बनाएं",
      "manageRoutes": "मार्ग प्रबंधित करें",
      "manageRoutesDescription": "मौजूदा बस मार्गों को देखें, संपादित करें या हटाएं",
      "manageRouteApprovals": "मार्ग अनुमोदन प्रबंधित करें",
      "reviewRouteApprovalsDescription": "लंबित मार्ग प्रस्तुतियों की समीक्षा और अनुमोदन करें",
      
      // Village/City Management
      "villageCityManagement": "गाँव/शहर प्रबंधन",
      "manageGeoDetailsDescription": "विभिन्न स्थानों और क्षेत्रों के भू-स्थानिक विवरण प्रबंधित करें",
      "addNewVillageCity": "नया गाँव/शहर जोड़ें",
      "registerNewVillageCityDescription": "एक नया गाँव/शहर पंजीकृत करें",
      "manageVillageCity": "गाँव/शहर प्रबंधित करें",
      "manageVillageCityDescription": "गाँव/शहर के विवरण देखें/बदलें/हटाएं",
      "manageRegionApprovals": "क्षेत्र अनुमोदन प्रबंधित करें",
      "reviewRegionApprovalsDescription": "लंबित गाँव/शहर प्रस्तुतियों की समीक्षा और अनुमोदन करें",
      
      // Management Cards
      "manageBusRoutes": "बस मार्ग प्रबंधित करें",
      "manageAllBusRoutesDescription": "सभी बस मार्गों, समय सारिणी, स्टॉप और मार्ग विवरण प्रबंधित करें",
      "geoSpotsRegions": "भू-स्थानिक स्थान और क्षेत्र",
      "manageGeoSpotsDescription": "विभिन्न स्थानों और क्षेत्रों के भू-स्थानिक विवरण प्रबंधित करें",
      "manageBusStopsCard": "बस स्टॉप प्रबंधित करें",
      "manageBusStopsLocationsDescription": "बस स्टॉप, स्थान और सुविधाएं प्रबंधित करें",
      "back": "वापस",
      "busInformation": "बस जानकारी",
      "busNumberLabel": "बस नंबर (5 से शुरू होने वाले 8 अंक)",
      "busNumberPlaceholder": "जैसे, 51234567",
      "busNumberHint": "5 से शुरू होने वाला 8-अंकीय नंबर दर्ज करें (50000000-59999999)",
      "generateRandomTitle": "यादृच्छिक बस नंबर उत्पन्न करें",
      "generate": "उत्पन्न करें",
      "checkAvailabilityTitle": "जाँचें कि बस नंबर उपलब्ध है या नहीं",
      "check": "जाँचें",
      "busNumberAvailableStatus": "यह बस नंबर उपलब्ध है",
      "busNumberTakenStatus": "यह बस नंबर पहले से लिया गया है",
      "invalidFormatStatus": "अमान्य प्रारूप। 5 से शुरू होने वाले 8 अंक होने चाहिए",
      
      "rtoRegistrationLabel": "आरटीओ पंजीकरण नंबर",
      "rtoPlaceholder": "जैसे, MP09FA1997",
      "rtoFormatHint": "प्रारूप: राज्य कोड(2) + अंक(2) + अक्षर(2) + अंक(4)",
      
      "busNameLabel": "बस का नाम",
      "busNamePlaceholder": "जैसे, वोल्वो एसी, सिटी एक्सप्रेस",
      
      "busContactLabel": "बस संपर्क नंबर",
      "contactPlaceholder": "जैसे, 9876543210",
      "contactHint": "10-अंकीय मोबाइल नंबर",
      
      "stateLabel": "राज्य",
      "selectStateOption": "-- राज्य चुनें --",
      "selected": "चयनित:",
      
      "zoneLabel": "क्षेत्र",
      "selectZoneOption": "-- क्षेत्र चुनें --",
      "selectStateFirst": "कृपया पहले एक राज्य चुनें",
      "noZonesAvailable": "इस राज्य के लिए कोई क्षेत्र उपलब्ध नहीं है",
      
      "statusLabel": "स्थिति",
      "activeService": "सक्रिय सेवा",
      "activeServiceHint": "बस बुकिंग के लिए उपलब्ध होगी",
      
      "operatorInformation": "ऑपरेटर जानकारी",
      "selectOperatorLabel": "ऑपरेटर चुनें",
      "selectOperatorOption": "-- ऑपरेटर चुनें --",
      "contact": "संपर्क",
      "appLink": "ऐप लिंक",
      "website": "वेबसाइट",
      
      "routeInformation": "मार्ग जानकारी",
      "selectRoutePathLabel": "मार्ग पथ चुनें",
      "selectRouteOption": "-- मार्ग पथ चुनें --",
      "routeNumber": "मार्ग नंबर",
      "routeName": "मार्ग का नाम",
      "routeVillagesCities": "मार्ग गाँव/शहर",
      
      "cancel": "रद्द करें",
      "registering": "पंजीकरण हो रहा है...",
      "registerBusService": "बस सेवा पंजीकृत करें",
      
      "registrationPreview": "पंजीकरण पूर्वावलोकन",
      "busDetails": "बस विवरण",
      "notSet": "सेट नहीं",
      "rtoRegistration": "आरटीओ पंजीकरण",
      "busName": "बस का नाम",
      "state": "राज्य",
      "zone": "क्षेत्र",
      "active": "सक्रिय",
      "inactive": "निष्क्रिय",
      "numberStatus": "नंबर स्थिति",
      "available": "उपलब्ध",
      "taken": "लिया गया",
      "invalid": "अमान्य",
      
      "operator": "ऑपरेटर",
      "name": "नाम",
      "number": "नंबर",
      "noOperatorSelected": "कोई ऑपरेटर चयनित नहीं",
      
      "route": "मार्ग",
      "pathId": "पथ आईडी",
      "villagesCities": "गाँव/शहर",
      "noRouteSelected": "कोई मार्ग चयनित नहीं",
      
      // Validation messages
      "busNumberRequired": "बस नंबर आवश्यक है",
      "busNumberFormatValidation": "बस नंबर 5 से शुरू होने वाले ठीक 8 अंक होने चाहिए",
      "busNumberRangeValidation": "बस नंबर 50000000 और 59999999 के बीच होना चाहिए",
      "rtoNumberRequired": "आरटीओ पंजीकरण नंबर आवश्यक है",
      "rtoNumberFormatError": "अमान्य प्रारूप। अपेक्षित: XX99XX9999 (जैसे, MP09FA1997)",
      "busNameRequired": "बस का नाम आवश्यक है",
      "selectOperatorRequired": "कृपया एक ऑपरेटर चुनें",
      "selectRouteRequired": "कृपया एक मार्ग पथ चुनें",
      "contactNumberRequired": "बस संपर्क नंबर आवश्यक है",
      "validContactNumberRequired": "कृपया एक वैध 10-अंकीय संपर्क नंबर दर्ज करें",
      "stateRequired": "राज्य आवश्यक है",
      "zoneRequired": "क्षेत्र आवश्यक है",
      
      // Toast messages
      "enterBusNumberToCheck": "जाँचने के लिए कृपया एक बस नंबर दर्ज करें",
      "busNumberFormatError": "बस नंबर 5 से शुरू होने वाले 8 अंक होने चाहिए",
      "busNumberAvailable": "बस नंबर उपलब्ध है!",
      "busNumberTaken": "बस नंबर पहले से लिया गया है",
      "checkAvailabilityFailed": "उपलब्धता जाँचने में विफल। कृपया पुनः प्रयास करें।",
      "fixFormErrors": "कृपया फॉर्म में त्रुटियाँ ठीक करें",
      "proceedWithoutVerification": "बस नंबर उपलब्धता सत्यापित नहीं हुई है। क्या आप फिर भी आगे बढ़ना चाहते हैं?",
      "busRegisteredSuccess": "बस सफलतापूर्वक पंजीकृत हुई",
      "serviceDetailsTitle": "सेवा विवरण",
      "busInformation": "बस जानकारी",
      "busNumber": "बस नंबर",
      "busName": "बस का नाम",
      "registrationNumber": "पंजीकरण नंबर",
      "contactNumber": "संपर्क नंबर",
      "operatorInformation": "ऑपरेटर जानकारी",
      "operatorNumber": "ऑपरेटर नंबर",
      "operatorName": "ऑपरेटर का नाम",
      "contact": "संपर्क",
      "routeInformation": "मार्ग जानकारी",
      "routePathNo": "मार्ग पथ नंबर",
      "routePathName": "मार्ग पथ का नाम",
      "routeNo": "मार्ग नंबर",
      "administrativeDetails": "प्रशासनिक विवरण",
      "stateCode": "राज्य कोड",
      "stateName": "राज्य का नाम",
      "zoneCode": "क्षेत्र कोड",
      "zoneName": "क्षेत्र का नाम",
      "serviceStatus": "सेवा स्थिति",
      "status": "स्थिति",
      "active": "सक्रिय",
      "inactive": "निष्क्रिय",
      "close": "बंद करें",
      "viewTravelHistory": "यात्रा इतिहास देखें",
      "travelHistoryTitle": "यात्रा इतिहास",
      "busService": "बस सेवा",
      "filterByStatus": "स्थिति के अनुसार फ़िल्टर करें",
      "allTrips": "सभी यात्राएं",
      "completed": "पूर्ण",
      "ongoing": "चल रहा",
      "cancelled": "रद्द",
      "delayed": "विलंबित",
      "totalTrips": "कुल यात्राएं",
      "totalPassengers": "कुल यात्री",
      "totalRevenue": "कुल राजस्व",
      "loadingTravelHistory": "यात्रा इतिहास लोड हो रहा है...",
      "noTravelHistory": "इस बस के लिए कोई यात्रा इतिहास उपलब्ध नहीं है",
      "date": "तारीख",
      "startTime": "प्रारंभ समय",
      "endTime": "समाप्ति समय",
      "driver": "चालक",
      "busNumber": "बस नंबर",
      "passengers": "यात्री",
      "revenue": "राजस्व",
      "incidents": "घटनाएं",
      "actions": "कार्रवाई",
      "none": "कोई नहीं",
      "exportHistory": "इतिहास निर्यात करें",
      "back": "वापस",
      "deactivateConfirm": "क्या आप वाकई इस बस सेवा को निष्क्रिय करना चाहते हैं? इससे स्थिति निष्क्रिय पर सेट हो जाएगी।",
      "deactivateSuccess": "बस सेवा सफलतापूर्वक निष्क्रिय हुई (स्थिति निष्क्रिय पर सेट)",
      "deactivateError": "बस सेवा निष्क्रिय करने में त्रुटि। कृपया पुनः प्रयास करें।",
      "loadingMasterData": "मास्टर डेटा लोड हो रहा है...",
      "operatorName": "ऑपरेटर का नाम",
      "selectOperator": "ऑपरेटर चुनें",
      "operatorNumber": "ऑपरेटर नंबर",
      "autoFilledOperator": "ऑपरेटर चुनने पर स्वतः भरेगा",
      "stateName": "राज्य का नाम",
      "selectState": "राज्य चुनें",
      "stateCode": "राज्य कोड",
      "autoFilledState": "राज्य चुनने पर स्वतः भरेगा",
      "zoneName": "क्षेत्र का नाम",
      "selectZone": "क्षेत्र चुनें",
      "zoneCode": "क्षेत्र कोड",
      "autoFilledZone": "क्षेत्र चुनने पर स्वतः भरेगा",
      "searching": "खोज रहा है...",
      "searchBuses": "बसें ढूंढें", // Fixed according to design doc
      "clearAll": "सभी साफ़ करें",
      "refresh": "ताज़ा करें",
      "exportData": "डेटा निर्यात करें",
      "searchResults": "खोज परिणाम",
      "busServices": "बस सेवाएं",
      "found": "मिले",
      "loadingSearchResults": "खोज परिणाम लोड हो रहे हैं...",
      "noServicesFound": "आपकी खोज मापदंडों से मेल खाने वाली कोई बस सेवा नहीं मिली",
      "registrationNo": "पंजीकरण नंबर",
      "routePath": "मार्ग पथ",
      "viewDetails": "विवरण देखें",
      "editService": "सेवा संपादित करें",
      "deactivateService": "सेवा निष्क्रिय करें",
      "na": "एन/ए",
      "searchError": "बसें खोजने में त्रुटि। कृपया पुनः प्रयास करें।",
      "registerNewBusOperator": "नया बस ऑपरेटर पंजीकृत करें",
      "fillDetailsBelow": "एक नए बस ऑपरेटर को पंजीकृत करने के लिए नीचे विवरण भरें",
      
      // Server error messages
      "serverResponseError": "सर्वर ने स्थिति {{status}} के साथ प्रतिक्रिया दी",
      "failedToLoadStates": "राज्य लोड करने में विफल",
      "failedToLoadZones": "क्षेत्र लोड करने में विफल",
      "failedToLoadDistricts": "जिले लोड करने में विफल",
      "failedToLoadCitiesVillages": "शहर/गाँव लोड करने में विफल",
      "failedToLoadData": "आवश्यक डेटा लोड करने में विफल। कृपया पुनः प्रयास करें।",
      "failedToLoadDataRetry": "डेटा लोड करने में विफल। कृपया पुनः प्रयास करें।",
      "registrationFailed": "पंजीकरण विफल",
      
      // Operator identification section
      "operatorIdentification": "ऑपरेटर पहचान",
      "operatorNumberLabel": "ऑपरेटर नंबर (4 से शुरू होने वाले 8 अंक)",
      "operatorNumberPlaceholder": "जैसे, 41234567",
      "operatorNumberHint": "4 से शुरू होने वाला 8-अंकीय नंबर दर्ज करें (40000000-49999999)",
      "generateOperatorNumber": "यादृच्छिक ऑपरेटर नंबर उत्पन्न करें",
      "checkAvailability": "ऑपरेटर नंबर उपलब्धता जाँचें",
      "operatorNumberAvailableIndicator": "ऑपरेटर नंबर उपलब्ध है",
      "operatorNumberTakenIndicator": "ऑपरेटर नंबर पहले से लिया गया है",
      "operatorNumberInvalidFormat": "अमान्य प्रारूप। 4 से शुरू होने वाले 8 अंक होने चाहिए",
      "enterOperatorNumber": "जाँचने के लिए कृपया एक ऑपरेटर नंबर दर्ज करें",
      "operatorNumberFormat": "ऑपरेटर नंबर 4 से शुरू होने वाले 8 अंक होने चाहिए",
      "operatorNumberTaken": "यह ऑपरेटर नंबर पहले से लिया गया है",
      "operatorNumberAvailable": "ऑपरेटर नंबर उपलब्ध है!",
      "operatorRegistered": "ऑपरेटर सफलतापूर्वक पंजीकृत हुआ!",
      
      // Validation messages
      "operatorNumberRequired": "ऑपरेटर नंबर आवश्यक है",
      "operatorNumberFormatValidation": "ऑपरेटर नंबर 4 से शुरू होने वाले ठीक 8 अंक होने चाहिए",
      "operatorNumberRange": "ऑपरेटर नंबर 40000000 और 49999999 के बीच होना चाहिए",
      
      // Operator Name section
      "operatorNameTitle": "ऑपरेटर का नाम",
      "englishName": "अंग्रेजी नाम",
      "englishNamePlaceholder": "जैसे, एबीसी बस सर्विसेज",
      "hindiName": "हिंदी नाम",
      "hindiNamePlaceholder": "जैसे, एबीसी बस सर्विसेज",
      "validateEnglishName": "अंग्रेजी नाम सत्यापित करें",
      "validateHindiName": "हिंदी नाम सत्यापित करें",
      "validate": "सत्यापित करें",
      "validNameIndicator": "मान्य नाम",
      "invalidCharactersIndicator": "अमान्य वर्ण शामिल हैं",
      "englishNameHint": "अंग्रेजी में ऑपरेटर नाम दर्ज करें (केवल अक्षर और रिक्त स्थान)",
      "hindiNameHint": "हिंदी में ऑपरेटर नाम दर्ज करें",
      "enterNameFirst": "कृपया पहले {{field}} नाम दर्ज करें",
      "invalidCharacters": "{{field}} नाम में अमान्य वर्ण शामिल हैं",
      "validName": "{{field}} नाम मान्य है!",
      "englishNameRequired": "अंग्रेजी ऑपरेटर नाम आवश्यक है",
      "hindiNameRequired": "हिंदी ऑपरेटर नाम आवश्यक है",
      
      // Location Information
      "locationInformation": "स्थान जानकारी",
      "selectState": "राज्य चुनें",
      "selectZone": "क्षेत्र चुनें",
      "selectDistrict": "ज़िला चुनें",
      "selectCityVillage": "शहर/गाँव चुनें",
      "stateRequired": "राज्य आवश्यक है",
      "zoneRequired": "क्षेत्र आवश्यक है",
      "districtRequired": "जिला आवश्यक है",
      "cityVillageRequired": "शहर/गाँव आवश्यक है",
      
      // Contact Information
      "contactInformation": "संपर्क जानकारी",
      "mobileNumber": "मोबाइल नंबर",
      "mobileNumberPlaceholder": "जैसे, 9876543210",
      "validateMobileNumber": "मोबाइल नंबर सत्यापित करें",
      "removeNumber": "यह नंबर हटाएं",
      "addAnotherMobileNumber": "एक और मोबाइल नंबर जोड़ें",
      "mobileNumberHint": "10-अंकीय भारतीय मोबाइल नंबर",
      "enterMobileNumber": "कृपया पहले एक मोबाइल नंबर दर्ज करें",
      "validMobileNumber": "मोबाइल नंबर मान्य है!",
      "invalidMobileNumber": "कृपया एक वैध 10-अंकीय मोबाइल नंबर दर्ज करें",
      "invalidMobileNumberFormat": "अमान्य मोबाइल नंबर प्रारूप",
      
      // Digital Presence
      "digitalPresence": "डिजिटल उपस्थिति",
      "googlePlayStoreLink": "Google Play Store लिंक",
      "googlePlayStorePlaceholder": "https://play.google.com/store/apps/details?id=...",
      "appleAppStoreLink": "Apple App Store लिंक",
      "appleAppStorePlaceholder": "https://apps.apple.com/in/app/...",
      "invalidUrlFormat": "अमान्य URL प्रारूप",
      
      // Status Settings
      "statusSettings": "स्थिति सेटिंग्स",
      "activeStatus": "सक्रिय स्थिति",
      "activeStatusHint": "सक्रिय ऑपरेटर बस सेवाओं के लिए उपलब्ध होंगे",
      
      // Loading states
      "loadingFormData": "फॉर्म डेटा लोड हो रहा है...",
      "retry": "पुनः प्रयास करें",
      "confirmCancel": "क्या आप सुनिश्चित हैं? सभी असुरक्षित परिवर्तन खो जाएंगे।",
      
      // Button labels
      "registerOperator": "ऑपरेटर पंजीकृत करें",
      "registering": "पंजीकरण हो रहा है...",
      "busOperatorsManagement": "बस ऑपरेटर प्रबंधन",
      "searchAndManageOperators": "सिस्टम में सभी बस ऑपरेटरों को खोजें और प्रबंधित करें",
      "loadingMasterData": "मास्टर डेटा लोड हो रहा है...",
      "noOperatorsFound": "आपकी खोज मापदंडों से मेल खाने वाला कोई ऑपरेटर नहीं मिला।",
      "searchError": "ऑपरेटर खोजने में त्रुटि। कृपया पुनः प्रयास करें।",
      
      // Search section
      "searchOperators": "ऑपरेटर खोजें",
      "enterOperatorName": "ऑपरेटर का नाम दर्ज करें",
      "enterOperatorNumber": "ऑपरेटर नंबर दर्ज करें",
      "selectState": "राज्य चुनें",
      "autoFilledState": "राज्य चुनने पर स्वतः भरेगा",
      "selectZone": "क्षेत्र चुनें",
      "autoFilledZone": "क्षेत्र चुनने पर स्वतः भरेगा",
      
      // Buttons
      "searching": "खोज रहा है...",
      "searchOperatorsButton": "ऑपरेटर खोजें",
      "clearAll": "सभी साफ़ करें",
      "refresh": "ताज़ा करें",
      "registerNewOperator": "नया ऑपरेटर पंजीकृत करें",
      
      // Table headers
      "searchResults": "खोज परिणाम",
      "operators": "ऑपरेटर",
      "found": "मिले",
      "contactNumber": "संपर्क नंबर",
      "links": "लिंक्स",
      
      // Table content
      "loadingOperators": "ऑपरेटर लोड हो रहे हैं...",
      "na": "एन/ए",
      "active": "सक्रिय",
      "inactive": "निष्क्रिय",
      "app": "ऐप",
      "website": "वेबसाइट",
      "noLinks": "कोई लिंक नहीं",
      
      // Action tooltips
      "clickToDeactivate": "निष्क्रिय करने के लिए क्लिक करें",
      "clickToActivate": "सक्रिय करने के लिए क्लिक करें",
      "viewDetails": "विवरण देखें",
      "deactivateOperator": "ऑपरेटर निष्क्रिय करें",
      
      // Confirmation messages
      "deactivateConfirm": "क्या आप वाकई इस ऑपरेटर को निष्क्रिय करना चाहते हैं? इससे स्थिति निष्क्रिय पर सेट हो जाएगी।",
      "deactivateSuccess": "ऑपरेटर सफलतापूर्वक निष्क्रिय हुआ (स्थिति निष्क्रिय पर सेट)",
      "deactivateFailed": "ऑपरेटर निष्क्रिय करने में विफल",
      "deactivateError": "ऑपरेटर निष्क्रिय करने में त्रुटि। कृपया पुनः प्रयास करें।",
      
      // Status update messages
      "statusUpdated": "ऑपरेटर {{status}} सफलतापूर्वक!",
      "activated": "सक्रिय किया गया",
      "deactivated": "निष्क्रिय किया गया",
      "updateStatusFailed": "ऑपरेटर स्थिति अपडेट करने में विफल",
      "updateStatusError": "ऑपरेटर स्थिति अपडेट करने में त्रुटि। कृपया पुनः प्रयास करें।",
      "addNewCityVillage": "नया शहर/गाँव जोड़ें",
      "createCityVillageDescription": "मार्ग योजना के लिए नए शहर या गाँव प्रविष्टियाँ बनाएं",
      "httpError": "HTTP त्रुटि! स्थिति:",
      "failedToLoadDistricts": "जिले लोड करने में विफल। कृपया पुनः प्रयास करें।",
      "creationFailed": "शहर/गाँव बनाने में विफल। स्थिति:",
      "cityVillageAdded": "शहर/गाँव सफलतापूर्वक जोड़ा गया!",
      "saveFailed": "शहर/गाँव सहेजने में विफल। कृपया अपना कनेक्शन जांचें और पुनः प्रयास करें।",
      
      // Form labels and placeholders
      "cityVillageInformation": "शहर/गाँव जानकारी",
      "cityVillageNameLabel": "शहर/गाँव का नाम",
      "cityVillageNamePlaceholder": "जैसे, मैसूरु शहर केंद्र",
      "cityVillageCode": "शहर/गाँव कोड",
      "cityVillageCodePlaceholder": "जैसे, MYC001",
      "uniqueIdentifierHint": "इस शहर/गाँव के लिए अद्वितीय पहचानकर्ता",
      "loadingDistricts": "जिले लोड हो रहे हैं...",
      
      // Status section
      "statusHint": "इस शहर/गाँव को निष्क्रिय चिह्नित करने के लिए अनचेक करें",
      
      // Button labels
      "creating": "बनाया जा रहा है...",
      "createCityVillage": "शहर/गाँव बनाएं",
      "cityVillageManagement": "शहर/गाँव प्रबंधन",
      "searchManageDescription": "कोड, राज्य या जिला फ़िल्टर का उपयोग करके शहर और गाँव डेटा खोजें और प्रबंधित करें",
      "failedToLoadStates": "राज्य डेटा लोड करने में विफल",
      "failedToLoadDistricts": "जिला डेटा लोड करने में विफल",
      "enterSearchCriteria": "कृपया कम से कम एक खोज मापदंड दर्ज करें",
      "httpError": "HTTP त्रुटि! स्थिति:",
      "noCityVillagesFound": "आपकी खोज मापदंडों से मेल खाने वाला कोई शहर/गाँव नहीं मिला",
      "failedToFetchData": "डेटा प्राप्त करने में विफल। कृपया अपने खोज मापदंड जांचें और पुनः प्रयास करें।",
      "searchFailed": "शहर/गाँव खोजने में विफल",
      "unknownError": "अज्ञात त्रुटि",
      
      // Search section
      "searchCriteria": "खोज मापदंड",
      "enterCodePlaceholder": "कोड दर्ज करें (जैसे, 613063)",
      "exactMatchRequired": "सटीक मिलान आवश्यक",
      "selectStateOptional": "राज्य चुनें (वैकल्पिक)",
      "loadingStates": "राज्य लोड हो रहे हैं...",
      "selectDistrictOptional": "ज़िला चुनें (वैकल्पिक)",
      "loadingDistricts": "जिले लोड हो रहे हैं...",
      
      // Status messages
      "deactivatedSuccess": "शहर/गाँव सफलतापूर्वक निष्क्रिय किया गया (स्थिति निष्क्रिय पर सेट)",
      "deactivateFailed": "शहर/गाँव निष्क्रिय करने में विफल:",
      "deactivateError": "शहर/गाँव निष्क्रिय करने में त्रुटि:",
      "statusUpdated": "शहर/गाँव {{status}} सफलतापूर्वक!",
      "activated": "सक्रिय किया गया",
      "deactivated": "निष्क्रिय किया गया",
      "updateStatusError": "शहर/गाँव स्थिति अपडेट करने में त्रुटि। कृपया पुनः प्रयास करें।",
      "details": "विवरण:",
      
      // Buttons and actions
      "clear": "साफ़ करें",
      "searching": "खोज रहा है...",
      "search": "खोजें",
      "searchingData": "शहर/गाँव डेटा खोज रहा है...",
      "recordsFound": "रिकॉर्ड मिले",
      "addNewCityVillage": "नया शहर/गाँव जोड़ें",
      "deactivateCityVillage": "शहर/गाँव निष्क्रिय करें",
      
      // Table headers
      "cityVillageName": "शहर/गाँव का नाम",
      "stateCode": "राज्य कोड",
      "districtCode": "जिला कोड",
      
      // UI messages
      "note": "नोट:",
      "searchInstructions": "खोजने के लिए तीन मापदंडों में से कम से कम एक दर्ज करें। आप कोड, राज्य और जिले के किसी भी संयोजन का उपयोग कर सकते हैं।",
      "searchResults": "खोज परिणाम",
      "noRecordsFound": "आपकी खोज मापदंडों से मेल खाने वाला कोई रिकॉर्ड नहीं मिला। विभिन्न फ़िल्टर आज़माएं।",
      "readyToSearch": "खोजने के लिए तैयार",
      "enterCriteriaMessage": "शहर/गाँव रिकॉर्ड खोजने के लिए ऊपर कम से कम एक खोज मापदंड दर्ज करें और 'खोजें' पर क्लिक करें।",
      "searchCombinationHint": "आप कोड, राज्य, जिला या किसी भी संयोजन से खोज सकते हैं।",
      
      // Modal and confirmations
      "confirmDeactivation": "निष्क्रियता की पुष्टि करें",
      "confirmDeactivationMessage": "क्या आप वाकई इस शहर/गाँव को निष्क्रिय करना चाहते हैं? इससे स्थिति निष्क्रिय पर सेट हो जाएगी।",
      
      // Common terms
      "unknown": "अज्ञात",
      "clickToDeactivate": "निष्क्रिय करने के लिए क्लिक करें",
      "clickToActivate": "सक्रिय करने के लिए क्लिक करें",
      "registerNewBusStand": "नया बस स्टैंड पंजीकृत करें",
      "fillDetailsBelow": "एक नए बस स्टैंड को पंजीकृत करने के लिए नीचे विवरण भरें",
      "failedToLoadCityVillageData": "शहर/गाँव डेटा लोड करने में विफल। कृपया बाद में पुनः प्रयास करें।",
      
      // Facility options (UI only)
      "waitingArea": "प्रतीक्षा क्षेत्र",
      "restrooms": "शौचालय",
      "foodCourt": "फूड कोर्ट",
      "atm": "एटीएम",
      "ticketCounter": "टिकट काउंटर",
      "medicalRoom": "चिकित्सा कक्ष",
      "parkingArea": "पार्किंग क्षेत्र",
      "wifi": "वाईफाई",
      "chargingStations": "चार्जिंग स्टेशन",
      "informationDesk": "सूचना डेस्क",
      "luggageStorage": "सामान भंडारण",
      "drinkingWater": "पीने का पानी",
      
      // Validation messages
      "busStandCodeRequired": "बस स्टैंड कोड आवश्यक है",
      "busStandNameRequired": "बस स्टैंड का नाम आवश्यक है",
      "cityVillageCodeRequired": "शहर/गाँव कोड आवश्यक है",
      "validLatitudeRequired": "मान्य अक्षांश आवश्यक है (-90 से 90)",
      "validLongitudeRequired": "मान्य देशांतर आवश्यक है (-180 से 180)",
      "invalidContactNumberFormat": "अमान्य संपर्क नंबर प्रारूप",
      "fixValidationErrors": "कृपया सबमिट करने से पहले सत्यापन त्रुटियों को ठीक करें।",
      
      // Basic Information section
      "basicInformation": "मूल जानकारी",
      "busStandCodeLabel": "बस स्टैंड कोड",
      "busStandCodePlaceholder": "जैसे, BS001",
      "busStandCodeHint": "बस स्टैंड के लिए अल्फ़ान्यूमेरिक कोड",
      "busStandNameLabel": "बस स्टैंड का नाम",
      "busStandNamePlaceholder": "जैसे, सेंट्रल बस टर्मिनल",
      "busStandNameHint": "बस स्टैंड का पूरा नाम (न्यूनतम 3 वर्ण)",
      
      // Location Details section
      "locationDetails": "स्थान विवरण",
      "selectCityVillageLabel": "शहर/गाँव चुनें",
      "searchCityVillagePlaceholder": "नाम या कोड से खोजें...",
      "selected": "चयनित",
      "searchAndSelectHint": "उपलब्ध शहरों/गाँवों में से खोजें और चुनें",
      "latitudeLabel": "अक्षांश",
      "getLocation": "स्थान प्राप्त करें",
      "latitudeHint": "-90 से 90 के बीच (जैसे, मुंबई के लिए 19.0760)",
      "longitudeLabel": "देशांतर",
      "longitudeHint": "-180 से 180 के बीच (जैसे, मुंबई के लिए 72.8777)",
      "elevationLabel": "ऊंचाई (वैकल्पिक)",
      "elevationPlaceholder": "जैसे, समुद्र तल से 14 मीटर ऊपर",
      "elevationHint": "वैकल्पिक - समुद्र तल से ऊंचाई",
      
      // Contact Information section
      "contactInformation": "संपर्क जानकारी",
      "contactNumberLabel": "संपर्क नंबर (वैकल्पिक)",
      "contactNumberPlaceholder": "जैसे, +91 9876543210",
      "contactNumberHint": "प्रारूप: +91 9876543210",
      
      // Success and error messages
      "busStandRegisteredSuccess": "बस स्टैंड \"{{name}}\" सफलतापूर्वक पंजीकृत हुआ! बस स्टैंड कोड: {{code}}",
      "busStandRegisteredAlert": "बस स्टैंड सफलतापूर्वक पंजीकृत हुआ",
      "busStandCodeExists": "बस स्टैंड कोड पहले से मौजूद है। कृपया एक अलग कोड का उपयोग करें।",
      "invalidData": "अमान्य डेटा। कृपया अपने इनपुट जांचें।",
      "cityVillageNotFound": "शहर/गाँव नहीं मिला। कृपया एक मान्य स्थान चुनें।",
      "serverError": "सर्वर त्रुटि: {{status}} - {{statusText}}",
      "networkError": "नेटवर्क त्रुटि। कृपया अपना कनेक्शन जांचें और पुनः प्रयास करें।",
      "unexpectedError": "एक अप्रत्याशित त्रुटि हुई। कृपया पुनः प्रयास करें।",
      
      // Confirmation and location messages
      "confirmCancel": "क्या आप सुनिश्चित हैं? सभी असुरक्षित परिवर्तन खो जाएंगे।",
      "unableToRetrieveLocation": "आपका स्थान प्राप्त करने में असमर्थ। कृपया निर्देशांक मैन्युअल रूप से दर्ज करें।",
      "geolocationNotSupported": "आपका ब्राउज़र जियोलोकेशन का समर्थन नहीं करता है।",
      
      // UI labels
      "noCityVillageFound": "कोई शहर/गाँव नहीं मिला",
      "na": "एन/ए",
      "active": "सक्रिय",
      "registerBusStand": "बस स्टैंड पंजीकृत करें",
      "registering": "पंजीकरण हो रहा है...",
      "busStandsManagement": "बस स्टैंड प्रबंधन",
      "searchManageBusStandsDescription": "राज्य, क्षेत्र या नाम से बस स्टैंड खोजें और प्रबंधित करें",
      "failedToLoadBusStandsData": "बस स्टैंड डेटा लोड करने में विफल",
      "failedToLoadStatesData": "राज्य डेटा लोड करने में विफल",
      "failedToLoadZonesData": "क्षेत्र डेटा लोड करने में विफल",
      "noBusStandsFound": "दिए गए मापदंडों के साथ कोई बस स्टैंड नहीं मिला",
      "failedToSearchBusStands": "बस स्टैंड खोजने में विफल",
      
      // Search form
      "searchBusStands": "बस स्टैंड खोजें",
      "enterBusStandCode": "बस स्टैंड कोड दर्ज करें",
      "searchByName": "नाम से खोजें",
      "selectState": "राज्य चुनें",
      "selectZone": "क्षेत्र चुनें",
      
      // Button labels
      "reset": "रीसेट करें",
      "searchBusStandsButton": "बस स्टैंड खोजें",
      "registerNewBusStandButton": "नया बस स्टैंड पंजीकृत करें",
      
      // Table headers and labels
      "busStandsFound": "बस स्टैंड मिले",
      "standCode": "स्टैंड कोड",
      "standName": "स्टैंड का नाम",
      "coordinates": "निर्देशांक",
      "elevation": "ऊंचाई",
      
      // Status and actions
      "openInGoogleMaps": "Google Maps में खोलें",
      "deactivateBusStand": "बस स्टैंड निष्क्रिय करें",
      "addNewBusStand": "नया बस स्टैंड जोड़ें",
      
      // Error and success messages
      "unknownError": "अज्ञात त्रुटि",
      "httpError": "HTTP त्रुटि! स्थिति:",
      "deactivatedSuccess": "बस स्टैंड सफलतापूर्वक निष्क्रिय किया गया (स्थिति निष्क्रिय पर सेट)",
      "deactivateFailed": "बस स्टैंड निष्क्रिय करने में विफल:",
      "deactivateError": "बस स्टैंड निष्क्रिय करने में त्रुटि:",
      "statusUpdated": "बस स्टैंड {{status}} सफलतापूर्वक!",
      "details": "विवरण:",
      "updateStatusError": "बस स्टैंड स्थिति अपडेट करने में त्रुटि। कृपया पुनः प्रयास करें।",
      
      // UI messages
      "noBusStandsFoundTitle": "कोई बस स्टैंड नहीं मिला",
      "enterSearchCriteria": "बस स्टैंड खोजने के लिए खोज मापदंड दर्ज करें",
      "searchingBusStands": "बस स्टैंड खोज रहा है...",
      
      // Modal messages
      "confirmDeactivationMessage": "क्या आप वाकई इस बस स्टैंड को निष्क्रिय करना चाहते हैं? इससे स्थिति निष्क्रिय पर सेट हो जाएगी।",
      "editBusServiceTitle": "बस सेवा संपादित करें: {{registrationNumber}}",
      "editBusServiceDescription": "बस सेवा \"{{busName}}\" के विवरण अपडेट करें",
      "busNotFound": "बस नंबर \"{{busNo}}\" के साथ बस सेवा नहीं मिली।",
      "failedToLoadBusData": "बस सेवा डेटा लोड करने में विफल। कृपया बाद में पुनः प्रयास करें।",
      "loadingBusServiceData": "बस सेवा डेटा लोड हो रहा है...",
      
      // Validation messages
      "busNumberRequired": "बस नंबर आवश्यक है",
      "busNumberMustBeNumber": "बस नंबर एक संख्या होनी चाहिए",
      "busNumberGreaterThanZero": "बस नंबर 0 से अधिक होना चाहिए",
      "registrationNumberRequired": "पंजीकरण नंबर आवश्यक है",
      "busNameRequired": "बस का नाम आवश्यक है",
      "selectOperatorRequired": "कृपया एक ऑपरेटर चुनें",
      "selectRoutePathRequired": "कृपया एक मार्ग पथ चुनें",
      "contactNumberRequired": "बस संपर्क नंबर आवश्यक है",
      "valid10DigitContactNumber": "कृपया एक वैध 10-अंकीय संपर्क नंबर दर्ज करें",
      "stateRequired": "राज्य आवश्यक है",
      "zoneRequired": "क्षेत्र आवश्यक है",
      "fixFormErrors": "कृपया फॉर्म में त्रुटियों को ठीक करें",
      
      // Form labels and placeholders
      "busNumberLabel": "बस नंबर",
      "busNumberPlaceholder": "जैसे, 101, 202, 303",
      "uniqueBusNumberHint": "एक अद्वितीय बस नंबर दर्ज करें",
      "registrationNumberLabel": "पंजीकरण नंबर",
      "registrationNumberPlaceholder": "जैसे, MP-01-MO-1234",
      "registrationNumberFormatHint": "प्रारूप: XX-XX-XX-XXXX",
      "busNameLabel": "बस का नाम",
      "busNamePlaceholder": "जैसे, वोल्वो एसी, सिटी एक्सप्रेस",
      "busContactNumberLabel": "बस संपर्क नंबर",
      "contactNumberPlaceholder": "जैसे, 9876543210",
      "contactNumberHint": "10-अंकीय मोबाइल नंबर",
      "stateLabel": "राज्य",
      "selectStateOption": "-- राज्य चुनें --",
      "selectedState": "चयनित: {{stateName}}",
      "zoneLabel": "क्षेत्र",
      "selectZoneOption": "-- क्षेत्र चुनें --",
      "selectStateFirst": "कृपया पहले एक राज्य चुनें",
      "noZonesAvailable": "इस राज्य के लिए कोई क्षेत्र उपलब्ध नहीं है",
      "selectedZone": "चयनित: {{zoneName}}",
      "statusLabel": "स्थिति",
      "activeService": "सक्रिय सेवा",
      "activeServiceHint": "बस बुकिंग के लिए उपलब्ध होगी",
      
      // Section titles
      "busInformation": "बस जानकारी",
      "operatorInformation": "ऑपरेटर जानकारी",
      "routeInformation": "मार्ग जानकारी",
      
      // Operator and route selection
      "selectOperatorLabel": "ऑपरेटर चुनें",
      "selectOperatorOption": "-- ऑपरेटर चुनें --",
      "selectRoutePathLabel": "मार्ग पथ चुनें",
      "selectRoutePathOption": "-- मार्ग पथ चुनें --",
      
      // Error and success messages
      "busUpdatedSuccess": "बस सेवा \"{{busName}}\" सफलतापूर्वक अपडेट की गई!",
      "busServiceNotFound": "बस सेवा नहीं मिली। यह हटाई गई हो सकती है।",
      "invalidData": "अमान्य डेटा। कृपया अपने इनपुट जांचें।",
      "busNumberConflict": "बस नंबर संघर्ष। कृपया एक अलग नंबर का उपयोग करें।",
      "serverError": "सर्वर त्रुटि: {{status}} - {{statusText}}",
      "networkError": "नेटवर्क त्रुटि। कृपया अपना कनेक्शन जांचें और पुनः प्रयास करें।",
      "unexpectedError": "एक अप्रत्याशित त्रुटि हुई। कृपया पुनः प्रयास करें।",
      
      // Delete related
      "confirmDeleteBusService": "क्या आप वाकई इस बस सेवा को हटाना चाहते हैं? यह क्रिया वापस नहीं की जा सकती।",
      "busServiceDeleted": "बस सेवा सफलतापूर्वक हटाई गई!",
      "busServiceNotFoundDelete": "बस सेवा नहीं मिली। यह पहले ही हटाई गई हो सकती है।",
      "failedToDeleteBusService": "बस सेवा हटाने में विफल। कृपया पुनः प्रयास करें।",
      "confirmCancelChanges": "क्या आप सुनिश्चित हैं? सभी असुरक्षित परिवर्तन खो जाएंगे।",
      "confirmDelete": "हटाने की पुष्टि करें",
      "confirmDeleteMessage": "क्या आप वाकई बस सेवा \"{{busName}}\" (बस नंबर: {{busNo}}) को हटाना चाहते हैं?",
      "deleteWarning": "यह क्रिया वापस नहीं की जा सकती। सभी संबंधित डेटा स्थायी रूप से हटा दिए जाएंगे।",
      "deletePermanently": "स्थायी रूप से हटाएं",
      
      // Button labels
      "deleteBusService": "बस सेवा हटाएं",
      "updateBusService": "बस सेवा अपडेट करें",
      "deleting": "हटाया जा रहा है...",
      "updating": "अपडेट हो रहा है...",
      
      // Preview section
      "updatePreview": "अपडेट पूर्वावलोकन",
      "busDetails": "बस विवरण",
      "notSet": "सेट नहीं",
      "registration": "पंजीकरण",
      "noOperatorSelected": "कोई ऑपरेटर चयनित नहीं",
      "noRouteSelected": "कोई मार्ग चयनित नहीं",
      "pathId": "पथ आईडी",
      
      // Common terms
      "appLink": "ऐप लिंक",
      "website": "वेबसाइट",
      "routeNumber": "मार्ग नंबर",
      "routeName": "मार्ग का नाम",
      // Add these to the hi.translation object
      "editBusStandTitle": "बस स्टैंड संपादित करें: {{busStandCode}}",
      "editBusStandDescription": "बस स्टैंड \"{{busStandName}}\" के विवरण अपडेट करें",
      "busStandNotFound": "बस स्टैंड कोड \"{{busStandCode}}\" के साथ बस स्टैंड नहीं मिला।",
      "failedToLoadBusStandData": "बस स्टैंड डेटा लोड करने में विफल। कृपया बाद में पुनः प्रयास करें।",
      "loadingBusStandData": "बस स्टैंड डेटा लोड हो रहा है...",
      
      // Validation messages
      "busStandCodeRequired": "बस स्टैंड कोड आवश्यक है",
      "busStandNameRequired": "बस स्टैंड का नाम आवश्यक है",
      "cityVillageCodeRequired": "शहर/गाँव कोड आवश्यक है",
      "validLatitudeRequired": "मान्य अक्षांश आवश्यक है (-90 से 90)",
      "validLongitudeRequired": "मान्य देशांतर आवश्यक है (-180 से 180)",
      "invalidContactNumberFormat": "अमान्य संपर्क नंबर प्रारूप",
      "fixValidationErrors": "कृपया सबमिट करने से पहले सत्यापन त्रुटियों को ठीक करें।",
      
      // Form labels and placeholders
      "busStandCodeLabel": "बस स्टैंड कोड",
      "busStandCodePlaceholder": "जैसे, BS001",
      "busStandCodeHint": "बस स्टैंड के लिए अल्फ़ान्यूमेरिक कोड",
      "busStandNameLabel": "बस स्टैंड का नाम",
      "busStandNamePlaceholder": "जैसे, सेंट्रल बस टर्मिनल",
      "busStandNameHint": "बस स्टैंड का पूरा नाम",
      "statusLabel": "स्थिति",
      "active": "सक्रिय",
      "activeHint": "बस स्टैंड को सक्रिय चिह्नित करने के लिए चेक करें",
      
      // Location Details section
      "locationDetails": "स्थान विवरण",
      "selectCityVillageLabel": "शहर/गाँव चुनें",
      "searchCityVillagePlaceholder": "नाम या कोड से खोजें...",
      "loading": "लोड हो रहा है...",
      "noCityVillageFound": "कोई शहर/गाँव नहीं मिला",
      "searchAndSelectHint": "उपलब्ध शहरों/गाँवों में से खोजें और चुनें",
      "selected": "चयनित",
      "latitudeLabel": "अक्षांश",
      "getLocation": "स्थान प्राप्त करें",
      "latitudeHint": "-90 से 90 के बीच (जैसे, मुंबई के लिए 19.0760)",
      "longitudeLabel": "देशांतर",
      "longitudeHint": "-180 से 180 के बीच (जैसे, मुंबई के लिए 72.8777)",
      "elevationLabel": "ऊंचाई (वैकल्पिक)",
      "elevationPlaceholder": "जैसे, समुद्र तल से 14 मीटर ऊपर",
      "elevationHint": "वैकल्पिक - समुद्र तल से ऊंचाई",
      
      // Contact Information section
      "contactInformation": "संपर्क जानकारी",
      "contactNumberLabel": "संपर्क नंबर (वैकल्पिक)",
      "contactNumberPlaceholder": "जैसे, +91 9876543210",
      "contactNumberHint": "प्रारूप: +91 9876543210",
      
      // Error and success messages
      "busStandUpdatedSuccess": "बस स्टैंड \"{{busStandName}}\" सफलतापूर्वक अपडेट हुआ!",
      "busStandNotFoundError": "बस स्टैंड नहीं मिला। यह हटाया गया हो सकता है।",
      "invalidData": "अमान्य डेटा। कृपया अपने इनपुट जांचें।",
      "busStandCodeConflict": "बस स्टैंड कोड संघर्ष। कृपया एक अलग कोड का उपयोग करें।",
      "serverError": "सर्वर त्रुटि: {{status}} - {{statusText}}",
      "networkError": "नेटवर्क त्रुटि। कृपया अपना कनेक्शन जांचें और पुनः प्रयास करें।",
      "unexpectedError": "एक अप्रत्याशित त्रुटि हुई। कृपया पुनः प्रयास करें।",
      
      // Delete related
      "confirmDeleteBusStand": "क्या आप वाकई इस बस स्टैंड को हटाना चाहते हैं? यह क्रिया वापस नहीं की जा सकती।",
      "busStandDeleted": "बस स्टैंड सफलतापूर्वक हटाया गया!",
      "busStandNotFoundDelete": "बस स्टैंड नहीं मिला। यह पहले ही हटाया गया हो सकता है।",
      "failedToDeleteBusStand": "बस स्टैंड हटाने में विफल। कृपया पुनः प्रयास करें।",
      "confirmCancelChanges": "क्या आप सुनिश्चित हैं? सभी असुरक्षित परिवर्तन खो जाएंगे।",
      "confirmDelete": "हटाने की पुष्टि करें",
      "confirmDeleteMessage": "क्या आप वाकई बस स्टैंड \"{{busStandName}}\" (कोड: {{busStandCode}}) को हटाना चाहते हैं?",
      "deleteWarning": "यह क्रिया वापस नहीं की जा सकती। सभी संबंधित डेटा स्थायी रूप से हटा दिए जाएंगे।",
      "deletePermanently": "स्थायी रूप से हटाएं",
      
      // Button labels
      "deleteBusStand": "बस स्टैंड हटाएं",
      "updateBusStand": "बस स्टैंड अपडेट करें",
      "deleting": "हटाया जा रहा है...",
      "updating": "अपडेट हो रहा है...",
      "cancel": "रद्द करें",
      
      // Location messages
      "unableToRetrieveLocation": "आपका स्थान प्राप्त करने में असमर्थ। कृपया निर्देशांक मैन्युअल रूप से दर्ज करें।",
      "geolocationNotSupported": "आपका ब्राउज़र जियोलोकेशन का समर्थन नहीं करता है।",
      
      // Modal messages
      "deleteModalTitle": "हटाने की पुष्टि करें",
      "warningText": "यह क्रिया वापस नहीं की जा सकती। सभी संबंधित डेटा स्थायी रूप से हटा दिए जाएंगे।",
      
      // Common terms
      "district": "जिला",
      "na": "एन/ए",
      "basicInformation": "मूल जानकारी",
      "editBusRoute": "बस मार्ग संपादित करें",
      "updateRouteDetails": "रूट विलेजेस पाथ नंबर: <1>{{id}}</1> के लिए मार्ग विवरण अपडेट करें",
      "backToRoutes": "मार्गों पर वापस जाएं",
      "routeUpdatedSuccessfully": "मार्ग सफलतापूर्वक अपडेट हुआ!",
      "redirectingToRoutes": "मार्ग प्रबंधन पर वापस जा रहा है...",
      "failedToLoadRouteData": "मार्ग डेटा लोड करने में विफल। कृपया पुनः प्रयास करें।",
      "failedToLoadMasterData": "मास्टर डेटा लोड करने में विफल। कृपया पेज रीफ्रेश करें।",
      "failedToUpdateRoute": "मार्ग अपडेट करने में विफल। कृपया पुनः प्रयास करें।",
      "routeVillagesPathNoRequired": "रूट विलेजेस पाथ नंबर आवश्यक है",
      "routePathNoRequired": "रूट पाथ नंबर आवश्यक है",
      "cityVillageCodeRequired": "शहर/गाँव कोड आवश्यक है",
      "loadingRouteData": "मार्ग डेटा लोड हो रहा है...",
      "routeVillagesPathNo": "रूट विलेजेस पाथ नंबर",
      "enterRouteVillagesPathNumber": "रूट विलेजेस पाथ नंबर दर्ज करें",
      "routePath": "मार्ग पथ",
      "current": "वर्तमान",
      "selectRoutePath": "मार्ग पथ चुनें",
      "loadingRoutePaths": "मार्ग पथ लोड हो रहे हैं...",
      "cityVillage": "शहर/गाँव",
      "selectCityVillage": "शहर/गाँव चुनें",
      "loadingVillages": "गाँव लोड हो रहे हैं...",
      "activeRoutesHint": "सक्रिय मार्ग खोज और बुकिंग के लिए उपलब्ध होंगे",
      "saving": "सहेजा जा रहा है...",
      "saveChanges": "परिवर्तन सहेजें",
      "currentRouteInformation": "वर्तमान मार्ग जानकारी",
      "routeVillagesPathNo": "रूट विलेजेस पाथ नंबर",
      "notSet": "सेट नहीं",
      "currentStatus": "वर्तमान स्थिति",
      "loadingMasterData": "मास्टर डेटा लोड हो रहा है...",
      "unknownVillage": "अज्ञात गाँव",
      "unknownRoute": "अज्ञात मार्ग",
      "addBusTimetable": "बस टाइमटेबल जोड़ें",
      "failedToFetchRoutePaths": "मार्ग पथ डेटा प्राप्त करने में विफल",
      "routePathRequired": "मार्ग पथ आवश्यक है",
      "busStandRequired": "बस स्टैंड आवश्यक है",
      "busNumberRequired": "बस नंबर आवश्यक है",
      "arrivalTimeRequired": "आगमन समय आवश्यक है",
      "departureTimeRequired": "प्रस्थान समय आवश्यक है",
      "departureAfterArrival": "प्रस्थान समय आगमन समय के बाद होना चाहिए",
      "timetableAddedSuccess": "टाइमटेबल प्रविष्टि सफलतापूर्वक जोड़ी गई!",
      "failedToAddTimetable": "टाइमटेबल प्रविष्टि जोड़ने में विफल। कृपया विवरण के लिए कंसोल जांचें।",
      "routePath": "मार्ग पथ",
      "selectRoutePath": "मार्ग पथ चुनें",
      "busStand": "बस स्टैंड",
      "loadingBusStands": "बस स्टैंड लोड हो रहे हैं...",
      "selectBusStand": "बस स्टैंड चुनें",
      "noBusStandsFound": "इस मार्ग पथ के लिए कोई बस स्टैंड नहीं मिला",
      "busNumber": "बस नंबर",
      "loadingBuses": "बसें लोड हो रही हैं...",
      "selectBus": "बस चुनें",
      "noBusesFound": "इस मार्ग पथ के लिए कोई बस नहीं मिली",
      "arrivalTime": "आगमन समय",
      "departureTime": "प्रस्थान समय",
      "addingTimetableEntry": "टाइमटेबल प्रविष्टि जोड़ी जा रही है...",
      "adding": "जोड़ा जा रहा है...",
      "addTimetableEntry": "टाइमटेबल प्रविष्टि जोड़ें",
      "resetForm": "फॉर्म रीसेट करें",
      "findBuses": "बसें खोजें",
      "from": "कहाँ से", // Fixed according to design doc
      "to": "कहाँ तक", // Fixed according to design doc
      "selectDepartureCity": "प्रस्थान शहर चुनें",
      "selectDestinationCity": "गंतव्य शहर चुनें",
      "searchBuses": "बस प्रदर्शक", // Fixed according to design doc
      "searching": "खोज रहा है...",
      "loadingCities": "शहर लोड हो रहे हैं...",
      "popularRoutes": "लोकप्रिय मार्ग",
      "selectBothLocations": "कृपया दोनों स्थान चुनें",
      "invalidCitySelection": "अमान्य शहर चयन",
      "failedToLoadCities": "शहर लोड करने में विफल। सैंपल डेटा का उपयोग किया जा रहा है।",
      "failedToSearchBuses": "बसें खोजने में विफल। कृपया पुनः प्रयास करें।",
      "bus": "बस",
      "unknownOperator": "अज्ञात ऑपरेटर",
      "na": "एन/ए",
      "pm": "PM",
      "am": "AM",
      "ac": "AC",
      "wifi": "वाईफाई",
      "charging": "चार्जिंग",
      "movie": "मूवी",
      "blanket": "कंबल",
      "snacks": "स्नैक्स",
      "water": "पानी",
      "sleeper": "स्लीपर",
      "seater": "सीटर",
      "busFinder": "बस प्रदर्शक", // Fixed according to design doc
      "home": "होम",
      "searchingForBuses": "बसें खोज रहा है...",
      "availableBuses": "उपलब्ध बसें",
      "filterResults": "परिणाम फ़िल्टर करें",
      "departure": "प्रस्थान",
      "duration": "अवधि",
      "arrival": "आगमन",
      "seatsAvailable": "उपलब्ध सीटें",
      "amenities": "सुविधाएँ",
      "showArrivalDepartureDetails": "आगमन और प्रस्थान विवरण दिखाएं",
      "busDetails": "बस विवरण",
      "busInformation": "बस जानकारी",
      "contact": "संपर्क",
      "route": "मार्ग",
      "routeNumber": "मार्ग नंबर",
      "busStand": "बस स्टैंड",
      "schedule": "शेड्यूल",
      "noBusesFound": "आपकी खोज के लिए कोई बस नहीं मिली",
      "tryDifferentRoutes": "अलग मार्ग आज़माएं",
      "busManagementSystem": "बस प्रबंधन प्रणाली",
      "footerDescription": "आरामदायक और विश्वसनीय बस यात्रा के लिए आपका विश्वसनीय साथी।",
      "quickLinks": "त्वरित लिंक",
      "notices": "सूचनाएं",
      "contactUs": "हमसे संपर्क करें",
      "support": "सहायता",
      "helpCenter": "सहायता केंद्र",
      "faq": "सामान्य प्रश्न",
      "privacyPolicy": "गोपनीयता नीति",
      "termsOfService": "सेवा की शर्तें",
      "allRightsReserved": "सर्वाधिकार सुरक्षित",
      "timetableManagement": "समय सारणी प्रबंधन",
      "addTimetable": "समय सारणी जोड़ें",
      "viewTimetables": "समय सारणी देखें",
      "importExport": "आयात/निर्यात",
      "addNewTimetableDescription": "बस स्टैंडों के लिए नई आगमन और प्रस्थान समय सारणी जोड़ें",
      "viewManageTimetablesDescription": "सभी समय सारणियों को देखें, खोजें और प्रबंधित करें",
      "importExportTimetablesDescription": "CSV प्रारूप में समय सारणी डेटा आयात या निर्यात करें",
      "manageBusTimetablesDescription": "बस स्टैंडों पर बस आगमन और प्रस्थान समय सारणी प्रबंधित करें",
      "addNewTimetableEntry": "बस स्टैंडों पर बसों के लिए नई आगमन और प्रस्थान समय सारणी जोड़ें",
      "busStand": "बस स्टैंड",
      "busNumber": "बस नंबर",
      "arrivalTime": "आगमन समय",
      "departureTime": "प्रस्थान समय",
      "activeStatus": "सक्रिय स्थिति",
      "selectBusStand": "एक बस स्टैंड चुनें",
      "selectBus": "एक बस चुनें",
      "busNo": "बस नंबर",
      "adding": "जोड़ा जा रहा है...",
      "addTimetable": "समय सारणी जोड़ें",
      "reset": "रीसेट करें",
      "searchTimetables": "समय सारणी खोजें...",
      "search": "खोजें",
      "filter": "फ़िल्टर",
      "allStatus": "सभी स्थितियाँ",
      "active": "सक्रिय",
      "inactive": "निष्क्रिय",
      "sortBy": "क्रमबद्ध करें",
      "apply": "लागू करें",
      "refresh": "ताज़ा करें",
      "exportCSV": "CSV निर्यात करें",
      "loadingTimetables": "समय सारणी लोड हो रही है...",
      "noTimetablesFound": "कोई समय सारणी नहीं मिली",
      "noTimetablesDescription": "अपनी खोज या फ़िल्टर मानदंड समायोजित करने का प्रयास करें",
      "busStandCode": "बस स्टैंड कोड",
      "busStandName": "बस स्टैंड नाम",
      "actions": "कार्रवाइयाँ",
      "edit": "संपादित करें",
      "delete": "हटाएँ",
      "editTimetable": "समय सारणी संपादित करें",
      "cancel": "रद्द करें",
      "update": "अपडेट करें",
      "confirmDelete": "हटाने की पुष्टि करें",
      "deleteTimetableConfirmation": "क्या आप वाकई इस समय सारणी को हटाना चाहते हैं?",
      "importTimetables": "समय सारणी आयात करें",
      "importDescription": "समय सारणी डेटा वाली CSV फ़ाइल अपलोड करें। उचित फ़ॉर्मेटिंग के लिए नीचे टेम्पलेट डाउनलोड करें।",
      "chooseCSVFile": "CSV फ़ाइल चुनें",
      "downloadTemplate": "टेम्पलेट डाउनलोड करें",
      "filePreview": "फ़ाइल पूर्वावलोकन",
      "fileName": "फ़ाइल नाम",
      "fileSize": "फ़ाइल आकार",
      "importing": "आयात हो रहा है...",
      "importData": "डेटा आयात करें",
      "clear": "साफ़ करें",
      "exportTimetables": "समय सारणी निर्यात करें",
      "exportDescription": "बैकअप या बाहरी उपयोग के लिए वर्तमान समय सारणी डेटा को CSV प्रारूप में निर्यात करें।",
      "exportAllData": "सभी डेटा निर्यात करें",
      "exportAllDescription": "सभी समय सारणी प्रविष्टियों को एक CSV फ़ाइल में निर्यात करें।",
      "exportAll": "सभी निर्यात करें",
      "exportByDate": "तिथि सीमा से निर्यात करें",
      "exportByDateDescription": "विशिष्ट तिथि सीमा के भीतर समय सारणियाँ निर्यात करें।",
      "startDate": "प्रारंभ तिथि",
      "endDate": "समाप्ति तिथि",
      "exportRange": "सीमा निर्यात करें",
      "timetableAddedSuccess": "समय सारणी सफलतापूर्वक जोड़ी गई!",
      "timetableUpdated": "समय सारणी सफलतापूर्वक अपडेट की गई!",
      "timetableDeleted": "समय सारणी सफलतापूर्वक हटाई गई!",
      "failedToLoadData": "डेटा लोड करने में विफल। कृपया पुनः प्रयास करें।",
      "addTimetableFailed": "समय सारणी जोड़ने में विफल: {message}",
      "unknownError": "अज्ञात त्रुटि",
      "addTimetableError": "समय सारणी जोड़ने में विफल। कृपया पुनः प्रयास करें।",
      "failedToLoadTimetables": "समय सारणी लोड करने में विफल। कृपया पुनः प्रयास करें।",
      "updateFailed": "समय सारणी अपडेट करने में विफल। कृपया पुनः प्रयास करें।",
      "updateError": "समय सारणी अपडेट करते समय त्रुटि। कृपया पुनः प्रयास करें।",
      "deleteFailed": "समय सारणी हटाने में विफल। कृपया पुनः प्रयास करें।",
      "deleteError": "समय सारणी हटाते समय त्रुटि। कृपया पुनः प्रयास करें।",
      "invalidFileType": "कृपया एक CSV फ़ाइल चुनें।",
      "selectFileFirst": "कृपया पहले एक फ़ाइल चुनें।",
      "importCompleted": "आयात सफलतापूर्वक पूरा हुआ!",
      "instructions": "निर्देश:",
      "instructionsTimeFormat": "समय प्रारूप: HH:mm (24-घंटे प्रारूप)",
      "instructionsStatus": "स्थिति: सक्रिय के लिए true, निष्क्रिय के लिए false",
      "instructionsBusStandCode": "बस स्टैंड कोड सिस्टम में मौजूद होना चाहिए",
      "instructionsBusNo": "बस नंबर सिस्टम में मौजूद होना चाहिए",
      "logoAlt": "बस प्रबंधन प्रणाली लोगो",
      "busFinder": "बस प्रदर्शक", // Fixed according to design doc
      "home": "होम",
      "findBuses": "बस प्रदर्शक", // Fixed according to design doc
      "departure": "प्रस्थान स्थान",
      "state": "राज्य",
      "selectState": "राज्य चुनें",
      "loadingStates": "राज्य लोड हो रहे हैं...",
      "noStatesAvailable": "कोई राज्य उपलब्ध नहीं है",
      "district": "जिला",
      "selectDistrict": "ज़िला चुनें",
      "loadingDistricts": "जिले लोड हो रहे हैं...",
      "noDistrictsAvailable": "कोई जिला उपलब्ध नहीं है",
      "city": "शहर/ग्राम",
      "selectCity": "शहर चुनें",
      "loadingCities": "शहर लोड हो रहे हैं...",
      "noCitiesAvailable": "कोई शहर उपलब्ध नहीं है",
      "destination": "गंतव्य स्थान",
      "searchBuses": "बस प्रदर्शक", // Fixed according to design doc
      "searching": "खोज रहे हैं...",
      "popularRoutes": "लोकप्रिय मार्ग",
      "availableBuses": "उपलब्ध बसें",
      "filterResults": "परिणाम फ़िल्टर करें",
      "duration": "अवधि",
      "arrival": "आगमन",
      "seatsAvailable": "उपलब्ध सीटें",
      "amenities": "सुविधाएँ",
      "showBusDetails": "बस विवरण दिखाएं",
      "busDetails": "बस विवरण",
      "busInformation": "बस सूचना",
      "contact": "संपर्क",
      "status": "स्थिति",
      "route": "मार्ग",
      "routeName": "मार्ग नाम",
      "routeNumber": "मार्ग संख्या",
      "busStand": "बस स्टैंड",
      "busStandContact": "बस स्टैंड संपर्क",
      "additionalDetails": "अतिरिक्त विवरण",
      "busStatus": "बस स्थिति",
      "operatorContact": "ऑपरेटर संपर्क",
      "zone": "क्षेत्र",
      "perPassenger": "प्रति यात्री",
      "selectSeats": "सीटें चुनें",
      "busInactive": "बस निष्क्रिय",
      "apiError": "एपीआई त्रुटि",
      "tryAgainLater": "कृपया बाद में पुनः प्रयास करें",
      "noBusesFound": "कोई बस नहीं मिली",
      "tryDifferentRoutes": "अलग मार्ग या तिथि आजमाएं",
      "busManagementSystem": "बस प्रबंधन प्रणाली",
      "footerDescription": "भारत भर में आरामदायक और सुरक्षित बस यात्राओं के लिए आपका विश्वसनीय साथी।",
      "quickLinks": "त्वरित लिंक",
      "notices": "नोटिस",
      "contactUs": "संपर्क करें",
      "support": "सहायता",
      "helpCenter": "सहायता केंद्र",
      "faq": "सामान्य प्रश्न",
      "privacyPolicy": "गोपनीयता नीति",
      "termsOfService": "सेवा की शर्तें",
      "allRightsReserved": "सभी अधिकार सुरक्षित",
      "selectBothLocations": "कृपया प्रस्थान और गंतव्य दोनों स्थान चुनें",
      "searchingForBuses": "बसें खोज रहे हैं...",
      "active": "सक्रिय",
      "inactive": "निष्क्रिय",
      "notAvailable": "उपलब्ध नहीं",
      "unknownRoute": "अज्ञात मार्ग",
      "mainBusStand": "मुख्य बस स्टैंड",
      "busDetails": "बस विवरण",
      "back": "वापस",
      "logoAlt": "राजदूत लोगो",
      "rajdootBusDetails": "राजदूत - बस विवरण",
      "home": "होम",
      "departureLocation": "प्रस्थान स्थान",
      "destinationLocation": "गंतव्य स्थान",
      "travelDuration": "यात्रा अवधि",
      "departureTime": "प्रस्थान समय",
      "arrivalTime": "आगमन समय",
      "routeDetails": "मार्ग विवरण",
      "totalDistance": "कुल दूरी",
      "averageSpeed": "औसत गति",
      "tollBooths": "टोल बूथ",
      "roadCondition": "सड़क की स्थिति",
      "popularBusStops": "लोकप्रिय बस स्टॉप",
      "type": "प्रकार",
      "timeFromIndore": "इंदौर से समय",
      "availableAmenities": "उपलब्ध सुविधाएं",
      "timetable": "समय सारणी",
      "contactDetails": "संपर्क विवरण",
      "appsWebsites": "एप्स और वेबसाइट",
      "busInformation": "बस की जानकारी",
      "completeTimetable": "पूरी समय सारणी",
      "showingSchedule": "सभी स्टॉप्स की समय सारणी दिखा रहा है",
      "busStopBusStand": "बस स्टॉप / बस स्टैंड",
      "arrival": "आगमन",
      "departure": "कहाँ से",
      "day": "दिन",
      "gpsLocation": "जीपीएस स्थान",
      "map": "मैप",
      "stopType": "स्टॉप प्रकार",
      "details": "विवरण",
      "mainStop": "मुख्य स्टॉप",
      "intermediateStop": "मध्यवर्ती स्टॉप",
      "hide": "छिपाएं",
      "view": "देखें",
      "pickupPoints": "पिकअप पॉइंट",
      "intermediateStops": "मध्यवर्ती स्टॉप",
      "time": "समय",
      "mobileNumbersBooking": "बुकिंग के लिए मोबाइल नंबर",
      "busOperatorContact": "बस ऑपरेटर संपर्क",
      "callNow": "अभी कॉल करें",
      "websitesBooking": "बुकिंग हेतु वेबसाइट", // Fixed according to design doc
      "mobileAppsBooking": "एप्प", // Fixed according to design doc
      "openWebsite": "वेबसाइट खोलें",
      "downloadApp": "डाउनलोड करें", // Fixed according to design doc
      "busNumber": "बस नंबर",
      "routeNumber": "रूट नंबर",
      "registrationYear": "पंजीकरण वर्ष",
      "busType": "बस का प्रकार",
      "seatingCapacity": "बैठने की क्षमता",
      "insuranceValidUntil": "बीमा वैध तक",
      "busStandInformation": "बस स्टैंड जानकारी",
      "departureStand": "प्रस्थान स्टैंड",
      "timings": "समय",
      "arrivalStand": "आगमन स्टैंड",
      "policiesTerms": "नीतियाँ और शर्तें",
      "cancellationPolicy": "कैंसिलेशन पॉलिसी",
      "luggageAllowance": "सामान की अनुमति",
      "boardingTime": "बोर्डिंग समय",
      "childPolicy": "बच्चों की नीति",
      "idProof": "आईडी प्रूफ",
      "rescheduling": "पुनर्निर्धारण",
      "additionalInformation": "अतिरिक्त जानकारी",
      "operatorAddress": "ऑपरेटर का पता",
      "yearsOfService": "सेवा के वर्ष",
      "totalBuses": "कुल बसें",
      "customerRating": "ग्राहक रेटिंग",
      "safetyRating": "सुरक्षा रेटिंग",
      "amenitiesFacilities": "सुविधाएं",
      "notAvailable": "उपलब्ध नहीं",
      "safetyAdditionalFacilities": "सुरक्षा और अतिरिक्त सुविधाएं",
      "bookNow": "अभी बुक करें",
      "shareDetails": "विवरण साझा करें",
      "rajdootBusService": "राजदूत बस सेवा",
      "footerDescription": "भारत की विश्वसनीय बस बुकिंग सेवा। सुरक्षित, आरामदायक और समय पर यात्रा अनुभव।",
      "quickLinks": "त्वरित लिंक",
      "findBus": "बस प्रदर्शक", // Fixed according to design doc
      "myBookings": "मेरी बुकिंग",
      "notices": "नोटिस",
      "helpSupport": "सहायता और समर्थन",
      "helpCenter": "सहायता केंद्र",
      "contactUs": "हमसे संपर्क करें",
      "faq": "सामान्य प्रश्न",
      "privacyPolicy": "गोपनीयता नीति",
      "contactInformation": "संपर्क जानकारी",
      "helpline": "हेल्पलाइन",
      "email": "ईमेल",
      "office": "कार्यालय",
      "rajdootExplorations": "राजदूत एक्सप्लोरेशंस",
      "allRightsReserved": "सर्वाधिकार सुरक्षित",
      "busName": "ओम मा महाशक्ति ट्रैवल्स",
      "acSeaterSleeper": "एसी सीटर/स्लीपर",
      "nonStop": "नॉन-स्टॉप",
      "ac": "एसी",
      "seater": "सीटर",
      "sleeper": "स्लीपर",
      "water": "पानी",
      "snacks": "स्नैक्स",
      "charging": "चार्जिंग",
      "wifi": "वाईफाई",
      "duration2h5m": "2 घंटे 5 मिनट",
      "mainBusStandPlatform": "मुख्य बस स्टैंड, प्लेटफॉर्म A-12",
      "pickup": "पिकअप",
      "collegeGate": "कॉलेज गेट के सामने",
      "mainHighwayRoad": "मुख्य हाईवे रोड",
      "drop": "ड्रॉप",
      "highwayCrossing": "हाईवे क्रॉसिंग",
      "finalDestinationStop": "अंतिम गंतव्य स्टॉप",
      "mainBusStandPlatformB": "मुख्य बस स्टैंड, प्लेटफॉर्म B-08",
      "major": "मुख्य",
      "landmark": "लैंडमार्क",
      "industrial": "औद्योगिक",
      "district": "ज़िला",
      "destination": "कहाँ तक",
      "highway": "हाईवे",
      "good": "अच्छा",
      "primaryBooking": "प्राथमिक बुकिंग",
      "whatsappBooking": "व्हाट्सएप बुकिंग",
      "smsBooking": "एसएमएस बुकिंग",
      "landline": "लैंडलाइन",
      "groupBooking": "समूह बुकिंग",
      "operatorMrMohan": "ऑपरेटर (श्री मोहन)",
      "managerMrsReena": "मैनेजर (श्रीमती रीना)",
      "emergency": "आपातकालीन",
      "complaints": "शिकायतें",
      "rajdootOfficialWebsite": "आधिकारिक वेबसाइट", // Fixed according to design doc
      "officialBookingPortal": "लाइव ट्रैकिंग के साथ आधिकारिक बुकिंग पोर्टल",
      "onlineBookingPortal": "ऑनलाइन बुकिंग पोर्टल",
      "directBooking": "तत्काल पुष्टि के साथ सीधी बुकिंग",
      "operatorWebsite": "ऑपरेटर वेबसाइट",
      "operatorOfficialSite": "ओम मा महाशक्ति ट्रैवल्स आधिकारिक साइट",
      "serviceFeedback": "सेवा प्रतिक्रिया",
      "rateYourJourney": "अपनी यात्रा का मूल्यांकन करें",
      "mpRoadwaysPortal": "एमपी रोडवेज पोर्टल",
      "governmentBusServices": "सरकारी बस सेवाएं पोर्टल",
      "seats42": "42 सीटें",
      "waitingRoom": "प्रतीक्षा कक्ष",
      "cafeteria": "कैफेटेरिया",
      "toilets": "शौचालय",
      "parking": "पार्किंग",
      "cloakRoom": "क्लोक रूम",
      "open247": "24/7 खुला",
      "waitingArea": "प्रतीक्षा क्षेत्र",
      "teaStall": "चाय की दुकान",
      "localTransportCounter": "स्थानीय परिवहन काउंटर",
      "airConditioning": "एयर कंडीशनिंग",
      "freeWifi": "मुफ्त वाईफाई",
      "chargingPorts": "चार्जिंग पोर्ट",
      "waterBottles": "पानी की बोतलें",
      "snacksPack": "स्नैक्स पैक",
      "blankets": "कंबल",
      "newspaperMagazine": "अखबार/पत्रिका",
      "entertainmentSystem": "मनोरंजन प्रणाली",
      "readingLights": "रीडिंग लाइट्स",
      "footRests": "फुट रेस्ट",
      "recliningSeats": "झुकने वाली सीटें",
      "curtains": "पर्दे",
      "gpsTracking": "जीपीएस ट्रैकिंग",
      "realTimeBusTracking": "रीयल-टाइम बस ट्रैकिंग",
      "cctvCameras": "सीसीटीवी कैमरे",
      "securitySurveillance": "24/7 सुरक्षा निगरानी",
      "immediateContactSupport": "तत्काल संपर्क सहायता",
      "travelInsurance": "यात्रा बीमा",
      "coveragePerPassenger": "₹5 लाख प्रति यात्री कवरेज",
      "firstAidBox": "प्राथमिक चिकित्सा बॉक्स",
      "medicalAssistance": "चिकित्सा सहायता उपलब्ध",
      "fireExtinguisher": "अग्निशामक",
      "safetyEquipment": "सुरक्षा उपकरण बोर्ड पर",
      "wheelchairAccess": "व्हीलचेयर पहुंच",
      "availableOnRequest": "अनुरोध पर उपलब्ध",
      "childSeats": "बच्चों की सीटें",
      "cancellationPolicyText": "प्रस्थान से 24 घंटे पहले रद्दीकरण की अनुमति (50% शुल्क)",
      "luggagePolicyText": "15 किलोग्राम प्रति यात्री (अतिरिक्त ₹50/किलो)",
      "boardingPolicyText": "प्रस्थान समय से 30 मिनट पहले रिपोर्ट करें",
      "childPolicyText": "5 वर्ष से कम उम्र के बच्चे मुफ्त (सीट नहीं)",
      "idProofPolicyText": "यात्रा के दौरान आईडी प्रूफ अनिवार्य",
      "smokingPolicyText": "धूम्रपान और शराब सख्त वर्जित",
      "petsPolicyText": "पालतू जानवरों की अनुमति नहीं",
      "lateBoardingPolicyText": "लेट बोर्डिंग की कोई जिम्मेदारी नहीं",
      "reschedulingPolicyText": "प्रस्थान से 6 घंटे पहले पुनर्निर्धारण की अनुमति",
      "refundPolicyText": "रिफंड 7 कार्य दिवसों के भीतर प्रोसेस किए जाते हैं",
      "years15": "15 वर्ष",
      "buses25": "25+ बसें",
      "routes50": "50+ रूट",
      "bestPrivateOperator": "बेस्ट प्राइवेट बस ऑपरेटर 2022",
      "partnerHotels": "5+ पार्टनर होटल ओवरनाइट स्टे के लिए",
      "shareWhatsappText": "राजदूत बस सेवा: ओम मा महाशक्ति ट्रैवल्स (73151001) - इंदौर से बड़वाह",
      "review1": "आरामदायक यात्रा, साफ बस, पेशेवर स्टाफ। सिफारिश करेंगे!",
      "review2": "समय पर सेवा, अच्छी सुविधाएं। ड्राइवर बहुत सावधान थे।",
      "review3": "पैसे का सही मूल्य। स्नैक्स की गुणवत्ता में सुधार कर सकते हैं।",
      "detailsCopied": "बस विवरण क्लिपबोर्ड पर कॉपी किया गया!",
      "regNo": "पंजीकरण नंबर",
      
      // Additional fixed translations from design doc
      "androidApp": "एंड्रॉइड एप्प", // Fixed typo from design doc
      "iosApp": "आई.ओ.एस. एप्प", // Fixed according to design doc
      "search": "ढूंढें" ,// For consistency
      
  "harikaName": "हरिका",
  "rameshName": "रमेश नेदियादथ",
  "frontendDeveloper": "फ्रंटेंड डेवलपर",
  "backendDeveloper": "बैकेंड डेवलपर",
  "frontendDesc": "फ्रंटेंड विकास और यूआई कार्यान्वयन",
  "backendDesc": "बैकेंड विकास और एपीआई एकीकरण",
  "aboutTeam": "हमारी टीम के बारे में",
  "implementingAgency": "परियोजना के लिए कार्यान्वयन एजेंसी",
  "developmentTeam": "विकास टीम",
  "back": "पीछे",
  "charteredAccountants": "चार्टर्ड अकाउंटेंट",
  "trademarkConsultants": "ट्रेडमार्क सलाहकार",
  "concept": "अवधारणा",
  "mvpVersion": "वर्तमान एमवीपी संस्करण",
  "mvpDescription": "न्यूनतम व्यवहार्य उत्पाद - नेटसृष्टि द्वारा विकसित और अनुरक्षित",
  "companyName": "राजदूत एक्सप्लोरेशंस",
  "allRightsReserved": "सर्वाधिकार सुरक्षित",
  "privacyPolicy": "गोपनीयता नीति",
  "termsOfService": "सेवा की शर्तें",
  "contactUs": "संपर्क करें"

    },
    
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'cookie', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
    },
  });

export default i18n;